import React from "react";

const icons = {
  money: (
    <svg
      version="1.0"
      width="217.000000pt"
      height="215.000000pt"
      viewBox="0 0 217.000000 215.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,215.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M1519 2132 c-26 -9 -317 -141 -647 -292 l-601 -275 831 -3 c457 -1
            833 -1 834 1 8 8 -230 514 -252 538 -22 23 -83 50 -110 49 -5 -1 -30 -9 -55
            -18z"
        />
        <path
          d="M110 1438 c-42 -26 -61 -45 -82 -87 l-28 -53 0 -557 c0 -621 -2 -599
            71 -668 70 -66 15 -63 1011 -63 858 0 905 1 943 19 22 10 54 34 72 52 65 68
            63 52 63 663 l0 554 -28 53 c-21 42 -40 61 -82 87 l-54 32 -916 0 -916 0 -54
            -32z m1025 -293 c17 -16 25 -35 25 -60 l0 -35 49 0 c64 0 79 -6 97 -41 17 -34
            10 -70 -18 -96 -16 -15 -43 -19 -147 -23 -124 -5 -126 -5 -129 -29 -5 -33 12
            -41 89 -41 87 0 143 -29 183 -93 60 -98 25 -223 -77 -275 -41 -22 -47 -29 -47
            -56 0 -58 -64 -101 -112 -75 -34 18 -47 40 -48 77 l0 32 -53 0 c-44 0 -58 4
            -77 25 -30 32 -31 79 -1 108 19 20 35 23 149 27 l127 5 0 30 0 30 -80 5 c-44
            3 -91 12 -105 19 -155 82 -149 295 10 361 25 10 30 18 30 47 0 44 37 83 80 83
            19 0 40 -9 55 -25z m-534 -268 c48 -32 67 -89 46 -139 -17 -41 -68 -78 -105
            -78 -124 0 -167 171 -58 224 44 22 78 20 117 -7z m1079 -32 c36 -19 60 -62 60
            -110 0 -26 -9 -45 -34 -73 -30 -32 -40 -37 -78 -37 -55 0 -95 25 -114 72 -43
            102 67 199 166 148z"
        />
      </g>
    </svg>
  ),

  "affillate-marketing": (
    <svg
      version="1.0"
      width="246.000000pt"
      height="248.000000pt"
      viewBox="0 0 246.000000 248.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,248.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M1115 2460 c-123 -25 -272 -112 -349 -206 -134 -162 -180 -394 -115
            -586 29 -89 99 -197 169 -261 68 -63 193 -130 275 -147 l55 -11 0 -95 0 -94
            -337 0 c-333 0 -339 -1 -388 -24 -104 -48 -148 -119 -153 -248 l-4 -86 -62
            -31 c-112 -55 -178 -143 -199 -265 -9 -54 -8 -74 8 -131 45 -168 186 -272 355
            -263 138 8 240 77 301 206 29 61 31 72 27 151 -3 65 -10 98 -28 136 -35 72
            -115 149 -178 171 l-52 19 0 70 c1 127 -4 125 389 125 l321 0 0 -94 0 -95 -54
            -24 c-79 -37 -144 -100 -179 -176 -26 -59 -29 -72 -25 -155 2 -69 8 -102 26
            -137 95 -193 335 -258 514 -139 95 63 148 168 148 292 0 97 -37 184 -104 246
            -46 42 -114 82 -141 82 -12 0 -15 17 -15 100 l0 100 326 0 326 0 29 -29 c26
            -27 29 -36 29 -95 l0 -66 -54 -24 c-73 -32 -136 -92 -172 -163 -24 -48 -30
            -73 -32 -145 -4 -82 -2 -91 32 -161 39 -81 90 -132 173 -170 74 -34 208 -31
            285 5 68 31 137 99 170 165 28 59 37 194 17 257 -29 91 -101 170 -195 213
            l-54 24 0 70 c0 38 -6 88 -12 110 -18 57 -82 127 -143 155 -49 23 -54 24 -387
            24 l-338 0 0 94 0 94 68 17 c194 47 361 203 428 400 23 68 27 97 27 190 1 197
            -67 346 -216 472 -135 114 -340 167 -512 133z m149 -306 c9 -8 16 -29 16 -45
            l0 -29 73 0 c61 0 77 -3 92 -20 15 -17 16 -24 7 -45 -11 -24 -16 -25 -92 -25
            l-80 0 0 -45 0 -45 41 0 c53 0 102 -30 124 -76 42 -89 -32 -194 -136 -194 -25
            0 -29 -4 -29 -28 0 -33 -16 -52 -45 -52 -29 0 -45 19 -45 52 l0 28 -72 0 c-97
            0 -135 34 -91 82 13 14 31 18 90 18 l73 0 0 40 c0 40 0 40 -37 40 -71 0 -143
            68 -143 135 0 67 72 135 143 135 36 0 37 1 37 35 0 49 42 71 74 39z"
        />
        <path
          d="M1120 1970 c-25 -25 -13 -56 26 -66 33 -9 46 6 42 47 -4 42 -36 51
            -68 19z"
        />
        <path
          d="M1280 1770 c0 -39 1 -40 35 -40 25 0 37 6 45 21 15 28 -12 59 -52 59
            -26 0 -28 -3 -28 -40z"
        />
      </g>
    </svg>
  ),

  "user-robot": (
    <svg
      version="1.0"
      width="208.000000pt"
      height="248.000000pt"
      viewBox="0 0 208.000000 248.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,248.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M1004 2471 c-45 -19 -64 -59 -64 -132 l0 -68 -202 -3 c-231 -4 -274
            -15 -369 -89 -82 -66 -149 -193 -149 -284 0 -32 -1 -32 -57 -38 -60 -6 -93
            -25 -127 -71 -19 -24 -21 -44 -24 -174 -2 -125 0 -152 15 -181 27 -51 66 -75
            131 -81 l57 -5 7 -60 c21 -169 160 -311 337 -345 74 -14 890 -13 966 1 172 32
            312 176 333 344 l7 60 57 5 c65 6 104 30 131 81 15 29 17 56 15 181 -3 130 -5
            150 -24 174 -34 46 -67 65 -126 71 l-55 6 -6 53 c-11 105 -83 223 -174 283
            -88 58 -152 71 -359 71 l-184 0 0 70 c0 62 -3 73 -27 100 -30 32 -75 45 -109
            31z m-136 -738 c69 -51 89 -130 53 -201 -50 -99 -172 -118 -249 -39 -56 58
            -63 124 -20 195 42 69 153 92 216 45z m501 7 c42 -21 75 -66 85 -115 21 -101
            -90 -203 -191 -176 -53 14 -80 36 -103 81 -70 138 72 280 209 210z"
        />
        <path
          d="M582 700 c-246 -65 -417 -251 -459 -499 -19 -111 -12 -146 36 -178
            l34 -23 846 0 c810 0 847 1 877 19 51 31 60 67 41 178 -34 209 -173 392 -360
            472 -107 46 -165 51 -564 50 -339 0 -386 -2 -451 -19z"
        />
      </g>
    </svg>
  ),

  decentralized: (
    <svg
      version="1.0"
      width="248.000000pt"
      height="248.000000pt"
      viewBox="0 0 248.000000 248.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,248.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M1167 2464 c-111 -34 -183 -157 -157 -271 15 -67 62 -130 117 -157
            l42 -21 1 -77 0 -78 70 0 70 0 0 78 1 77 42 21 c57 28 103 90 117 159 24 117
            -47 235 -161 269 -63 19 -80 19 -142 0z"
        />
        <path
          d="M435 2161 c-84 -39 -135 -120 -135 -216 0 -64 15 -106 55 -153 57
            -67 170 -98 250 -69 l40 15 55 -52 55 -53 46 48 46 47 -52 52 -53 52 15 45
            c38 111 -23 243 -134 290 -46 19 -140 16 -188 -6z"
        />
        <path
          d="M1855 2166 c-110 -48 -170 -179 -132 -289 l15 -45 -53 -52 -52 -52
            48 -48 49 -49 51 54 50 53 46 -15 c111 -38 243 23 290 134 19 46 16 140 -6
            188 -23 49 -74 99 -123 119 -45 19 -142 20 -183 2z"
        />
        <path
          d="M1098 1691 c-145 -47 -269 -174 -312 -320 -20 -69 -20 -180 -1 -256
            41 -157 187 -298 346 -334 56 -13 162 -13 218 0 159 36 305 177 346 334 64
            248 -75 501 -316 576 -79 25 -203 24 -281 0z"
        />
        <path
          d="M177 1466 c-185 -51 -233 -296 -79 -412 112 -86 286 -50 346 73 l21
            42 78 1 77 0 0 70 0 70 -79 0 c-73 0 -79 2 -85 23 -9 36 -63 94 -108 115 -59
            28 -114 34 -171 18z"
        />
        <path
          d="M2177 1466 c-60 -17 -116 -61 -142 -114 l-20 -41 -77 -1 -78 0 0 -70
            0 -70 78 0 77 -1 21 -42 c42 -87 154 -138 252 -116 95 21 161 87 183 183 37
            168 -125 318 -294 272z"
        />
        <path
          d="M700 795 l-52 -53 -45 15 c-84 29 -191 -1 -248 -69 -40 -48 -55 -89
            -55 -155 1 -135 100 -233 235 -233 64 0 106 15 153 55 67 57 98 170 69 250
            l-15 40 52 55 53 55 -48 46 -47 46 -52 -52z"
        />
        <path
          d="M1679 800 l-46 -48 52 -52 53 -52 -15 -45 c-38 -111 23 -243 134
            -290 43 -18 135 -17 181 3 49 20 100 70 123 119 22 48 25 142 6 188 -47 111
            -179 172 -290 134 l-46 -15 -51 54 c-28 30 -52 54 -53 53 -1 -1 -23 -23 -48
            -49z"
        />
        <path
          d="M1170 541 c0 -76 -1 -79 -26 -85 -14 -4 -45 -26 -69 -51 -135 -135
            -69 -352 121 -396 157 -36 307 115 274 276 -14 69 -60 131 -117 159 l-42 21
            -1 78 0 77 -70 0 -70 0 0 -79z"
        />
      </g>
    </svg>
  ),
  "Mask-group": (
    <svg
      version="1.0"
      width="217.000000pt"
      height="215.000000pt"
      viewBox="0 0 217.000000 215.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,215.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M1519 2132 c-26 -9 -317 -141 -647 -292 l-601 -275 831 -3 c457 -1
            833 -1 834 1 8 8 -230 514 -252 538 -22 23 -83 50 -110 49 -5 -1 -30 -9 -55
            -18z"
        />
        <path
          d="M110 1438 c-42 -26 -61 -45 -82 -87 l-28 -53 0 -557 c0 -621 -2 -599
            71 -668 70 -66 15 -63 1011 -63 858 0 905 1 943 19 22 10 54 34 72 52 65 68
            63 52 63 663 l0 554 -28 53 c-21 42 -40 61 -82 87 l-54 32 -916 0 -916 0 -54
            -32z m1025 -293 c17 -16 25 -35 25 -60 l0 -35 49 0 c64 0 79 -6 97 -41 17 -34
            10 -70 -18 -96 -16 -15 -43 -19 -147 -23 -124 -5 -126 -5 -129 -29 -5 -33 12
            -41 89 -41 87 0 143 -29 183 -93 60 -98 25 -223 -77 -275 -41 -22 -47 -29 -47
            -56 0 -58 -64 -101 -112 -75 -34 18 -47 40 -48 77 l0 32 -53 0 c-44 0 -58 4
            -77 25 -30 32 -31 79 -1 108 19 20 35 23 149 27 l127 5 0 30 0 30 -80 5 c-44
            3 -91 12 -105 19 -155 82 -149 295 10 361 25 10 30 18 30 47 0 44 37 83 80 83
            19 0 40 -9 55 -25z m-534 -268 c48 -32 67 -89 46 -139 -17 -41 -68 -78 -105
            -78 -124 0 -167 171 -58 224 44 22 78 20 117 -7z m1079 -32 c36 -19 60 -62 60
            -110 0 -26 -9 -45 -34 -73 -30 -32 -40 -37 -78 -37 -55 0 -95 25 -114 72 -43
            102 67 199 166 148z"
        />
      </g>
    </svg>
  ),

  Navbar: (
    <svg width="22" height="17" viewBox="0 0 22 17" fill="none">
      <path
        d="M1.66797 1.36719H20.3346M1.66797 8.36719H20.3346M1.66797 15.3672H9.83464"
        stroke="#495E7A"
      />
    </svg>
  ),

  Shadow: (
    <svg width="80" height="79" viewBox="0 0 80 79" fill="none">
      <g filter="url(#filter0_f_3030_53272)">
        <ellipse
          cx="40"
          cy="39.5"
          rx="16"
          ry="15.5"
          fill="#7433FF"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_3030_53272"
          x="0"
          y="0"
          width="80"
          height="79"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood fillOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="12"
            result="effect1_foregroundBlur_3030_53272"
          />
        </filter>
      </defs>
    </svg>
  ),

  userArrowUp: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3333 38.3333C23.3333 39.25 22.5833 40 21.6667 40H1.66667C0.75 40 0 39.25 0 38.3333C0 31.8833 5.21667 26.6667 11.6667 26.6667C18.1167 26.6667 23.3333 31.8833 23.3333 38.3333ZM18.3333 16.6667C18.3333 12.9833 15.35 10 11.6667 10C7.98333 10 5 12.9833 5 16.6667C5 20.35 7.98333 23.3333 11.6667 23.3333C15.35 23.3333 18.3333 20.35 18.3333 16.6667ZM31.6667 0H15C10.5167 0 6.88333 3.56667 6.7 8C8.16667 7.15 9.85 6.66667 11.6667 6.66667C16.2333 6.66667 20.0667 9.73333 21.2667 13.9167L25 17.65L30.9833 11.6667H28.3333C27.4167 11.6667 26.6667 10.9167 26.6667 10C26.6667 9.08333 27.4167 8.33333 28.3333 8.33333H33.3333C35.1667 8.33333 36.6667 9.83333 36.6667 11.6667V16.6667C36.6667 17.5833 35.9167 18.3333 35 18.3333C34.0833 18.3333 33.3333 17.5833 33.3333 16.6667V14.0167L27.35 20C26.05 21.3 23.9333 21.3 22.6333 20L21.4333 18.8C21.4333 18.8 21.4333 18.8167 21.4333 18.8333C20.9167 21.1833 19.5667 23.2167 17.7167 24.6167C20.3333 25.7667 22.55 27.65 24.1333 30H31.6833C36.2833 30 40.0167 26.2667 40.0167 21.6667V8.33333C40.0167 3.73333 36.2833 0 31.6833 0H31.6667Z"
        fill="#006BFF"
      />
    </svg>
  ),

  graphicArrow: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.4896 32.1017L34.4963 28.1083C33.6979 27.31 32.3329 27.875 32.3329 29.0033V31.3767C31.0063 30.5733 29.6779 28.1033 28.5729 26.0283C26.9229 22.9283 25.7813 20 23.1663 20C20.5513 20 19.4096 22.9283 17.7596 26.0283C16.4229 28.54 14.7596 31.6667 13.1663 31.6667H9.83295C9.83295 31.6667 11.1996 30.2567 12.4846 28.3333C12.9596 27.6967 14.2646 25.5 14.8163 24.4617C16.6663 20.9867 18.5496 16.6667 23.1663 16.6667C23.9613 16.6667 25.0996 16.8017 25.7663 17.0317C23.7996 10.5333 22.0696 6.66667 18.9996 6.66667C15.3113 6.66667 13.5596 12.2017 11.0079 21.2333C10.3079 23.7117 8.66628 26.9917 7.33295 29.2333V6.66667H9.93128C11.0596 6.66667 11.6246 5.30167 10.8263 4.50333L6.83295 0.51C6.15295 -0.17 5.04961 -0.17 4.36961 0.51L0.37628 4.50333C-0.422053 5.30167 0.142947 6.66667 1.27128 6.66667H3.99795V28.3333C3.99795 32.015 6.98295 35 10.6646 35H32.3313V37.6633C32.3313 38.7917 33.6963 39.3567 34.4946 38.5583L38.4879 34.565C39.1679 33.885 39.1696 32.7817 38.4896 32.1017Z"
        fill="#006BFF"
      />
    </svg>
  ),

  dashboard: (
    <svg
      width="40"
      height="38"
      viewBox="0 0 40 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.6667 0.666626H8.33333C3.73833 0.666626 0 4.40496 0 8.99996V22.3333C0 26.9283 3.73833 30.6666 8.33333 30.6666H18.3333V34H11.6667C10.7467 34 10 34.7466 10 35.6666C10 36.5866 10.7467 37.3333 11.6667 37.3333H28.3333C29.2533 37.3333 30 36.5866 30 35.6666C30 34.7466 29.2533 34 28.3333 34H21.6667V30.6666H31.6667C36.2617 30.6666 40 26.9283 40 22.3333V8.99996C40 4.40496 36.2617 0.666626 31.6667 0.666626ZM33.3333 17.2966C33.3333 18.2166 32.5867 18.9633 31.6667 18.9633C30.7467 18.9633 30 18.2166 30 17.2966V14.6916L24.16 20.5316C22.6917 22.0016 20.13 22.0016 18.6617 20.5316L15.5583 17.4283C15.3417 17.2116 14.99 17.2116 14.7733 17.4283L9.51667 22.685C9.19167 23.01 8.765 23.1733 8.33833 23.1733C7.91167 23.1733 7.485 23.01 7.16 22.685C6.50833 22.0333 6.50833 20.98 7.16 20.3283L12.4167 15.0716C13.9317 13.555 16.4 13.555 17.915 15.0716L21.0183 18.175C21.3017 18.4583 21.52 18.4583 21.8033 18.175L27.6433 12.335H25C24.08 12.335 23.3333 11.5883 23.3333 10.6683C23.3333 9.74829 24.08 9.00163 25 9.00163H30.8333C32.2117 9.00163 33.3333 10.1233 33.3333 11.5016V17.2983V17.2966Z"
        fill="#006BFF"
      />
    </svg>
  ),

  userRobot: (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.332 40H3.66536C2.74536 40 1.9987 39.255 1.9987 38.3333C1.9987 32.8183 6.4837 28.3333 11.9987 28.3333H21.9987C27.5137 28.3333 31.9987 32.8183 31.9987 38.3333C31.9987 39.255 31.252 40 30.332 40ZM31.1654 10H30.332C30.332 6.32333 27.342 3.33333 23.6654 3.33333H18.6654V1.66667C18.6654 0.745 17.9187 0 16.9987 0C16.0787 0 15.332 0.745 15.332 1.66667V3.33333H10.332C6.65536 3.33333 3.66536 6.32333 3.66536 10H2.83203C1.4537 10 0.332031 11.1217 0.332031 12.5V15.8333C0.332031 17.2117 1.4537 18.3333 2.83203 18.3333H3.66536C3.66536 22.01 6.65536 25 10.332 25H23.6654C27.342 25 30.332 22.01 30.332 18.3333H31.1654C32.5437 18.3333 33.6654 17.2117 33.6654 15.8333V12.5C33.6654 11.1217 32.5437 10 31.1654 10ZM12.832 16.6667C11.452 16.6667 10.332 15.5467 10.332 14.1667C10.332 12.7867 11.452 11.6667 12.832 11.6667C14.212 11.6667 15.332 12.7867 15.332 14.1667C15.332 15.5467 14.212 16.6667 12.832 16.6667ZM21.1654 16.6667C19.7854 16.6667 18.6654 15.5467 18.6654 14.1667C18.6654 12.7867 19.7854 11.6667 21.1654 11.6667C22.5454 11.6667 23.6654 12.7867 23.6654 14.1667C23.6654 15.5467 22.5454 16.6667 21.1654 16.6667Z"
        fill="#006BFF"
      />
    </svg>
  ),

  search: (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="5"
        cy="5"
        r="4.3"
        stroke="var(--textColor)"
        strokeWidth="1.4"
      />
      <line
        x1="10.0101"
        y1="11"
        x2="8"
        y2="8.98995"
        stroke="var(--textColor)"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),

  arrowUpArounded: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 40C23.9556 40 27.8224 38.827 31.1114 36.6294C34.4004 34.4318 36.9638 31.3082 38.4776 27.6537C39.9913 23.9992 40.3874 19.9778 39.6157 16.0982C38.844 12.2186 36.9392 8.65492 34.1421 5.85787C31.3451 3.06082 27.7814 1.15601 23.9018 0.384303C20.0222 -0.387401 16.0009 0.00866572 12.3463 1.52242C8.69181 3.03617 5.56824 5.59962 3.37061 8.8886C1.17298 12.1776 0 16.0444 0 20C0.00573514 25.3026 2.11471 30.3863 5.8642 34.1358C9.61368 37.8853 14.6974 39.9943 20 40ZM20 3.33334C23.2964 3.33334 26.5187 4.31083 29.2595 6.14218C32.0003 7.97354 34.1365 10.5765 35.398 13.622C36.6595 16.6674 36.9895 20.0185 36.3464 23.2515C35.7033 26.4845 34.116 29.4542 31.7851 31.7851C29.4542 34.116 26.4845 35.7033 23.2515 36.3464C20.0185 36.9895 16.6674 36.6595 13.6219 35.398C10.5765 34.1365 7.97353 32.0003 6.14217 29.2595C4.31082 26.5187 3.33333 23.2964 3.33333 20C3.33819 15.5812 5.09569 11.3448 8.22025 8.22025C11.3448 5.0957 15.5812 3.3382 20 3.33334ZM10.4883 18.1317C10.8009 18.4441 11.2247 18.6197 11.6667 18.6197C12.1086 18.6197 12.5325 18.4441 12.845 18.1317L18.3333 12.645L18.345 30C18.345 30.442 18.5206 30.866 18.8332 31.1785C19.1457 31.4911 19.5696 31.6667 20.0117 31.6667C20.4537 31.6667 20.8776 31.4911 21.1902 31.1785C21.5027 30.866 21.6783 30.442 21.6783 30L21.6667 12.6433L27.155 18.1317C27.3053 18.2958 27.487 18.4282 27.6894 18.521C27.8917 18.6138 28.1106 18.6652 28.3331 18.672C28.5556 18.6788 28.7772 18.641 28.9848 18.5607C29.1925 18.4805 29.382 18.3595 29.5421 18.2048C29.7022 18.0502 29.8297 17.865 29.9171 17.6603C30.0044 17.4556 30.0499 17.2354 30.0508 17.0128C30.0517 16.7902 30.008 16.5697 29.9223 16.3642C29.8365 16.1588 29.7105 15.9726 29.5517 15.8167L29.5117 15.775L23.5367 9.79834C23.0724 9.33396 22.5211 8.96559 21.9144 8.71426C21.3078 8.46293 20.6575 8.33358 20.0008 8.33358C19.3442 8.33358 18.6939 8.46293 18.0872 8.71426C17.4805 8.96559 16.9293 9.33396 16.465 9.79834L10.4883 15.775C10.1759 16.0876 10.0004 16.5114 10.0004 16.9533C10.0004 17.3953 10.1759 17.8191 10.4883 18.1317Z"
        fill="#6933FF"
      />
    </svg>
  ),

  chevronDown: (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.5L5 5.5L1 1.5"
        stroke="#495E7A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  bell: (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99979 0.5C5.40849 0.5 3.88236 1.13214 2.75715 2.25736C1.63193 3.38258 0.999787 4.9087 0.999787 6.5V10.086L0.292787 10.793C0.152977 10.9329 0.057771 11.111 0.0192035 11.305C-0.0193641 11.4989 0.000438951 11.7 0.076109 11.8827C0.151779 12.0654 0.279918 12.2215 0.444328 12.3314C0.608738 12.4413 0.802037 12.5 0.999787 12.5H12.9998C13.1975 12.5 13.3908 12.4413 13.5552 12.3314C13.7197 12.2215 13.8478 12.0654 13.9235 11.8827C13.9991 11.7 14.0189 11.4989 13.9804 11.305C13.9418 11.111 13.8466 10.9329 13.7068 10.793L12.9998 10.086V6.5C12.9998 4.9087 12.3676 3.38258 11.2424 2.25736C10.1172 1.13214 8.59109 0.5 6.99979 0.5ZM6.99979 16.5C6.20414 16.5 5.44108 16.1839 4.87847 15.6213C4.31586 15.0587 3.99979 14.2956 3.99979 13.5H9.99979C9.99979 14.2956 9.68372 15.0587 9.12111 15.6213C8.5585 16.1839 7.79544 16.5 6.99979 16.5Z"
        fill="#495E7A"
      />
    </svg>
  ),

  checkedBallon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8363 0.0292653C11.122 -0.0906812 9.40197 0.158997 7.79256 0.761407C6.18315 1.36382 4.72192 2.3049 3.50774 3.52098C2.29356 4.73706 1.35475 6.19976 0.754857 7.8101C0.15496 9.42045 -0.0920346 11.1409 0.0305868 12.8549C0.471541 19.2073 6.08296 23.9988 13.0832 23.9988H18.9996C20.3251 23.9972 21.5958 23.47 22.533 22.5327C23.4703 21.5955 23.9975 20.3248 23.9991 18.9993V12.34C24.0364 9.25776 22.9063 6.27551 20.8358 3.99203C18.7652 1.70854 15.9074 0.292875 12.8363 0.0292653ZM18.6997 9.71226L11.9074 16.4186C11.5325 16.7919 11.0251 17.0016 10.496 17.0016C9.96695 17.0016 9.45946 16.7919 9.08465 16.4186L5.30104 12.715C5.11143 12.5293 5.00333 12.276 5.00052 12.0106C4.9977 11.7453 5.10041 11.4897 5.28604 11.3001C5.47167 11.1105 5.72503 11.0024 5.99036 10.9996C6.2557 10.9968 6.51129 11.0995 6.7009 11.2851L10.4935 14.9917L17.2988 8.29241C17.4907 8.12355 17.74 8.03461 17.9955 8.04385C18.2509 8.05308 18.4931 8.15981 18.6723 8.34209C18.8515 8.52437 18.9541 8.76836 18.959 9.02394C18.9639 9.27951 18.8707 9.52725 18.6987 9.71626L18.6997 9.71226Z"
        fill="white"
      />
    </svg>
  ),

  dashboardIcon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66664 0H11.6666C15.3485 0 18.3333 2.98477 18.3333 6.66664V11.6666C18.3333 15.3485 15.3485 18.3333 11.6666 18.3333H6.66664C2.98477 18.3334 0 15.3486 0 11.6666V6.66664C0 2.98477 2.98477 0 6.66664 0Z"
        fill="#006BFF"
      />
      <path
        d="M28.3331 0H33.3331C37.015 0 39.9998 2.98477 39.9998 6.66664V11.6666C39.9998 15.3485 37.015 18.3333 33.3331 18.3333H28.3331C24.6513 18.3333 21.6665 15.3485 21.6665 11.6666V6.66664C21.6664 2.98477 24.6512 0 28.3331 0Z"
        fill="#006BFF"
      />
      <path
        d="M6.66664 21.6667H11.6666C15.3485 21.6667 18.3333 24.6515 18.3333 28.3334V33.3334C18.3333 37.0153 15.3485 40 11.6666 40H6.66664C2.98477 40.0001 0 37.0153 0 33.3335V28.3335C0 24.6515 2.98477 21.6667 6.66664 21.6667Z"
        fill="#006BFF"
      />
      <path
        d="M28.3331 21.6667H33.3331C37.015 21.6667 39.9998 24.6515 39.9998 28.3334V33.3334C39.9998 37.0153 37.015 40.0001 33.3331 40.0001H28.3331C24.6513 40.0001 21.6665 37.0153 21.6665 33.3335V28.3335C21.6664 24.6515 24.6512 21.6667 28.3331 21.6667Z"
        fill="#006BFF"
      />
    </svg>
  ),

  looserRobot: (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.3335 40H3.66683C2.74516 40 2.00016 39.2533 2.00016 38.3333C2.00016 32.8183 6.48516 28.3333 12.0002 28.3333H22.0002C27.5152 28.3333 32.0002 32.8183 32.0002 38.3333C32.0002 39.2533 31.2552 40 30.3335 40ZM31.1668 10H30.3335C30.3335 6.32333 27.3435 3.33333 23.6668 3.33333H18.6668V1.66667C18.6668 0.746667 17.9218 0 17.0002 0C16.0785 0 15.3335 0.746667 15.3335 1.66667V3.33333H10.3335C6.65683 3.33333 3.66683 6.32333 3.66683 10H2.8335C1.45516 10 0.333496 11.1217 0.333496 12.5V15.8333C0.333496 17.2117 1.45516 18.3333 2.8335 18.3333H3.66683C3.66683 22.01 6.65683 25 10.3335 25H23.6668C27.3435 25 30.3335 22.01 30.3335 18.3333H31.1668C32.5452 18.3333 33.6668 17.2117 33.6668 15.8333V12.5C33.6668 11.1217 32.5452 10 31.1668 10ZM14.4285 15.0717C15.0802 15.7233 15.0802 16.7767 14.4285 17.4283C14.1035 17.7533 13.6768 17.9167 13.2502 17.9167C12.8235 17.9167 12.3968 17.7533 12.0718 17.4283L11.1668 16.5233L10.2618 17.4283C9.93683 17.7533 9.51016 17.9167 9.0835 17.9167C8.65683 17.9167 8.23016 17.7533 7.90516 17.4283C7.2535 16.7767 7.2535 15.7233 7.90516 15.0717L8.81016 14.1667L7.90516 13.2617C7.2535 12.61 7.2535 11.5567 7.90516 10.905C8.55683 10.2533 9.61016 10.2533 10.2618 10.905L11.1668 11.81L12.0718 10.905C12.7235 10.2533 13.7768 10.2533 14.4285 10.905C15.0802 11.5567 15.0802 12.61 14.4285 13.2617L13.5235 14.1667L14.4285 15.0717ZM26.0952 15.0717C26.7468 15.7233 26.7468 16.7767 26.0952 17.4283C25.7702 17.7533 25.3435 17.9167 24.9168 17.9167C24.4902 17.9167 24.0635 17.7533 23.7385 17.4283L22.8335 16.5233L21.9285 17.4283C21.6035 17.7533 21.1768 17.9167 20.7502 17.9167C20.3235 17.9167 19.8968 17.7533 19.5718 17.4283C18.9202 16.7767 18.9202 15.7233 19.5718 15.0717L20.4768 14.1667L19.5718 13.2617C18.9202 12.61 18.9202 11.5567 19.5718 10.905C20.2235 10.2533 21.2768 10.2533 21.9285 10.905L22.8335 11.81L23.7385 10.905C24.3902 10.2533 25.4435 10.2533 26.0952 10.905C26.7468 11.5567 26.7468 12.61 26.0952 13.2617L25.1902 14.1667L26.0952 15.0717Z"
        fill="#495E7A"
      />
    </svg>
  ),

  wallet: (
    <svg
      width="40"
      height="34"
      viewBox="0 0 40 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 6.99992H8.33333C6.90167 6.99992 5.54667 6.37992 4.60833 5.33492C5.525 4.31159 6.85667 3.66659 8.33333 3.66659H38.3333C40.5133 3.65659 40.5117 0.341585 38.3333 0.333252H8.33333C3.73167 0.333252 0 4.06492 0 8.66659V25.3333C0 29.9349 3.73167 33.6666 8.33333 33.6666H35C37.7617 33.6666 40 31.4283 40 28.6666V11.9999C40 9.23825 37.7617 6.99992 35 6.99992ZM33.3333 21.9999C31.1533 21.9899 31.1533 18.6766 33.3333 18.6666C35.5133 18.6766 35.5133 21.9899 33.3333 21.9999Z"
        fill="#495E7A"
      />
    </svg>
  ),

  chatrThree: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.6667 30.3065V29.9999C36.664 27.7906 35.7852 25.6725 34.223 24.1102C32.6607 22.548 30.5427 21.6692 28.3333 21.6665H21.6667V19.8499C24.139 19.432 26.3641 18.1005 27.9011 16.1194C29.438 14.1383 30.1747 11.6521 29.965 9.15348C29.7553 6.65487 28.6146 4.3262 26.769 2.62895C24.9233 0.931704 22.5074 -0.0102539 20 -0.0102539C17.4926 -0.0102539 15.0767 0.931704 13.2311 2.62895C11.3854 4.3262 10.2447 6.65487 10.035 9.15348C9.82535 11.6521 10.562 14.1383 12.0989 16.1194C13.6359 18.1005 15.861 19.432 18.3333 19.8499V21.6665H11.6667C9.45735 21.6692 7.33927 22.548 5.77704 24.1102C4.21481 25.6725 3.33599 27.7906 3.33334 29.9999V30.3065C2.22132 30.6997 1.28409 31.4733 0.687291 32.4907C0.0904958 33.508 -0.127435 34.7036 0.0720175 35.8661C0.27147 37.0286 0.875462 38.0832 1.77724 38.8434C2.67902 39.6036 3.82053 40.0206 5.00001 40.0206C6.17949 40.0206 7.321 39.6036 8.22278 38.8434C9.12456 38.0832 9.72855 37.0286 9.928 35.8661C10.1275 34.7036 9.90952 33.508 9.31273 32.4907C8.71593 31.4733 7.7787 30.6997 6.66668 30.3065V29.9999C6.66668 28.6738 7.19346 27.402 8.13114 26.4643C9.06882 25.5267 10.3406 24.9999 11.6667 24.9999H18.3333V30.3065C17.2213 30.6997 16.2841 31.4733 15.6873 32.4907C15.0905 33.508 14.8726 34.7036 15.072 35.8661C15.2715 37.0286 15.8755 38.0832 16.7772 38.8434C17.679 39.6036 18.8205 40.0206 20 40.0206C21.1795 40.0206 22.321 39.6036 23.2228 38.8434C24.1246 38.0832 24.7286 37.0286 24.928 35.8661C25.1275 34.7036 24.9095 33.508 24.3127 32.4907C23.7159 31.4733 22.7787 30.6997 21.6667 30.3065V24.9999H28.3333C29.6594 24.9999 30.9312 25.5267 31.8689 26.4643C32.8066 27.402 33.3333 28.6738 33.3333 29.9999V30.3065C32.2213 30.6997 31.2841 31.4733 30.6873 32.4907C30.0905 33.508 29.8726 34.7036 30.072 35.8661C30.2715 37.0286 30.8755 38.0832 31.7772 38.8434C32.679 39.6036 33.8205 40.0206 35 40.0206C36.1795 40.0206 37.321 39.6036 38.2228 38.8434C39.1246 38.0832 39.7285 37.0286 39.928 35.8661C40.1275 34.7036 39.9095 33.508 39.3127 32.4907C38.7159 31.4733 37.7787 30.6997 36.6667 30.3065Z"
        fill="#495E7A"
      />
    </svg>
  ),

  moneyTransferCoin: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.3333 1.66667V8.33333C38.3333 10.175 36.8417 11.6667 35 11.6667H28.3333C27.4133 11.6667 26.6667 10.92 26.6667 10C26.6667 9.08 27.4133 8.33333 28.3333 8.33333H31.885C28.7917 5.16333 24.57 3.33333 20 3.33333C10.81 3.33333 3.33333 10.81 3.33333 20C3.33333 20.92 2.58667 21.6667 1.66667 21.6667C0.746667 21.6667 0 20.92 0 20C0 8.97167 8.97167 0 20 0C25.8617 0 31.2383 2.515 35 6.81833V1.66667C35 0.746667 35.7467 0 36.6667 0C37.5867 0 38.3333 0.746667 38.3333 1.66667ZM38.3333 18.3333C37.4133 18.3333 36.6667 19.08 36.6667 20C36.6667 29.19 29.19 36.6667 20 36.6667C15.43 36.6667 11.2083 34.8367 8.115 31.6667H11.6667C12.5867 31.6667 13.3333 30.92 13.3333 30C13.3333 29.08 12.5867 28.3333 11.6667 28.3333H5C3.15833 28.3333 1.66667 29.825 1.66667 31.6667V38.3333C1.66667 39.2533 2.41333 40 3.33333 40C4.25333 40 5 39.2533 5 38.3333V33.1817C8.76167 37.485 14.1383 40 20 40C31.0283 40 40 31.0283 40 20C40 19.08 39.2533 18.3333 38.3333 18.3333ZM33.3333 20C33.3333 27.3633 27.3633 33.3333 20 33.3333C18.56 33.3333 17.175 33.0983 15.8767 32.675C16.3717 31.9 16.6667 30.985 16.6667 30C16.6667 29.6483 16.6283 29.305 16.5583 28.9733C16.5033 28.8783 16.4267 28.8 16.38 28.7C15.2017 28.3283 14.1417 27.6233 13.33 26.6467C12.945 26.1817 12.715 25.645 12.5733 25.0917C12.2783 25.0367 11.9767 25 11.6667 25H7.645C7.01833 23.455 6.66667 21.77 6.66667 20C6.66667 12.6367 12.6367 6.66667 20 6.66667C21.44 6.66667 22.825 6.90167 24.1233 7.325C23.6283 8.1 23.3333 9.015 23.3333 10C23.3333 10.3517 23.3717 10.695 23.4417 11.0267C23.4967 11.1217 23.5733 11.2 23.62 11.3C24.7983 11.6717 25.8583 12.3767 26.67 13.3533C27.055 13.8183 27.285 14.355 27.4267 14.9083C27.7217 14.9633 28.0233 15 28.3333 15H32.355C32.9817 16.545 33.3333 18.23 33.3333 20ZM22.5883 19.1583L17.935 18.2267C17.4283 18.125 17.0783 17.6267 17.1867 17.0967C17.2783 16.6433 17.7017 16.3333 18.165 16.3333H21.6683C22.0067 16.3333 22.3133 16.4783 22.5267 16.71C22.7833 16.9883 23.1283 17.1667 23.5067 17.1667H23.6333C24.7233 17.1667 25.3167 15.895 24.62 15.0567C23.9167 14.2083 22.855 13.6683 21.67 13.6683H21.3367V13.0017C21.3367 12.265 20.74 11.6683 20.0033 11.6683C19.2667 11.6683 18.67 12.265 18.67 13.0017V13.6683H18.2033C16.385 13.6683 14.7933 14.9783 14.5383 16.7783C14.2667 18.7083 15.56 20.4717 17.4133 20.8433L22.065 21.775C22.5717 21.8783 22.9217 22.3733 22.8167 22.9033C22.7267 23.3583 22.3033 23.67 21.84 23.67H18.335C17.9967 23.67 17.69 23.525 17.4767 23.2933C17.22 23.015 16.875 22.8367 16.4967 22.8367H16.37C15.28 22.8367 14.6867 24.1083 15.3833 24.9467C16.0867 25.795 17.1483 26.335 18.3333 26.335H18.6667V27.0017C18.6667 27.7383 19.2633 28.335 20 28.335C20.7367 28.335 21.3333 27.7383 21.3333 27.0017V26.335H21.8C23.6183 26.335 25.21 25.0267 25.465 23.2267C25.7383 21.2967 24.4433 19.5317 22.59 19.1617L22.5883 19.1583Z"
        fill="#006BFF"
      />
    </svg>
  ),

  info: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 40C23.9556 40 27.8224 38.827 31.1114 36.6294C34.4004 34.4318 36.9638 31.3082 38.4776 27.6537C39.9913 23.9992 40.3874 19.9778 39.6157 16.0982C38.844 12.2186 36.9392 8.65492 34.1421 5.85787C31.3451 3.06082 27.7814 1.15601 23.9018 0.384303C20.0222 -0.387401 16.0009 0.00866572 12.3463 1.52242C8.69181 3.03617 5.56824 5.59962 3.37061 8.8886C1.17298 12.1776 0 16.0444 0 20C0.00573514 25.3026 2.11471 30.3863 5.8642 34.1358C9.61368 37.8853 14.6974 39.9943 20 40ZM20 8.33334C20.4945 8.33334 20.9778 8.47996 21.3889 8.75467C21.8 9.02937 22.1205 9.41982 22.3097 9.87663C22.4989 10.3334 22.5484 10.8361 22.452 11.3211C22.3555 11.806 22.1174 12.2515 21.7678 12.6011C21.4181 12.9507 20.9727 13.1888 20.4877 13.2853C20.0028 13.3818 19.5001 13.3323 19.0433 13.143C18.5865 12.9538 18.196 12.6334 17.9213 12.2223C17.6466 11.8111 17.5 11.3278 17.5 10.8333C17.5 10.1703 17.7634 9.53442 18.2322 9.06557C18.7011 8.59673 19.337 8.33334 20 8.33334ZM18.3333 16.6667H20C20.8841 16.6667 21.7319 17.0179 22.357 17.643C22.9821 18.2681 23.3333 19.116 23.3333 20V30C23.3333 30.442 23.1577 30.866 22.8452 31.1785C22.5326 31.4911 22.1087 31.6667 21.6667 31.6667C21.2246 31.6667 20.8007 31.4911 20.4882 31.1785C20.1756 30.866 20 30.442 20 30V20H18.3333C17.8913 20 17.4674 19.8244 17.1548 19.5119C16.8423 19.1993 16.6667 18.7754 16.6667 18.3333C16.6667 17.8913 16.8423 17.4674 17.1548 17.1548C17.4674 16.8423 17.8913 16.6667 18.3333 16.6667Z"
        fill="#6933FF"
      />
    </svg>
  ),

  leave: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 25C40 26.0283 39.6 26.995 38.87 27.7233L35.4167 31.1783C35.0917 31.5033 34.665 31.6666 34.2383 31.6666C33.8117 31.6666 33.385 31.5033 33.06 31.1783C32.4083 30.5266 32.4083 29.4733 33.06 28.8216L35.2133 26.6666H25C24.0783 26.6666 23.3333 25.9216 23.3333 25C23.3333 24.0783 24.0783 23.3333 25 23.3333H35.2133L33.06 21.1783C32.4083 20.5266 32.4083 19.4733 33.06 18.8216C33.7117 18.17 34.765 18.17 35.4167 18.8216L38.8717 22.2783C39.6 23.005 40 23.9716 40 25ZM23.3333 18.3333V9.99998C23.3333 8.16165 21.8383 6.66665 20 6.66665V36.665H21.6667C22.5867 36.665 23.3333 35.9183 23.3333 34.9983V31.665C23.3333 30.7433 24.0783 29.9983 25 29.9983C25.9217 29.9983 26.6667 30.7433 26.6667 31.665V34.9983C26.6667 37.755 24.4233 39.9983 21.6667 39.9983H5C2.24333 39.9983 0 37.755 0 34.9983V9.36831C0 5.40998 2.81667 1.97331 6.69833 1.19665L12.0267 0.131647C13.995 -0.261687 16.0117 0.241647 17.5617 1.51331C18.1867 2.02498 18.67 2.65498 19.065 3.33331H20C23.6767 3.33331 26.6667 6.32331 26.6667 9.99998V18.3333C26.6667 19.255 25.9217 20 25 20C24.0783 20 23.3333 19.255 23.3333 18.3333ZM15 20.8333C15 19.4533 13.88 18.3333 12.5 18.3333C11.12 18.3333 10 19.4533 10 20.8333C10 22.2133 11.12 23.3333 12.5 23.3333C13.88 23.3333 15 22.2133 15 20.8333Z"
        fill="#6933FF"
      />
    </svg>
  ),

  plusAround: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM9 5C9 4.73478 8.89464 4.48043 8.70711 4.29289C8.51957 4.10536 8.26522 4 8 4C7.73478 4 7.48043 4.10536 7.29289 4.29289C7.10536 4.48043 7 4.73478 7 5V7H5C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8C4 8.26522 4.10536 8.51957 4.29289 8.70711C4.48043 8.89464 4.73478 9 5 9H7V11C7 11.2652 7.10536 11.5196 7.29289 11.7071C7.48043 11.8946 7.73478 12 8 12C8.26522 12 8.51957 11.8946 8.70711 11.7071C8.89464 11.5196 9 11.2652 9 11V9H11C11.2652 9 11.5196 8.89464 11.7071 8.70711C11.8946 8.51957 12 8.26522 12 8C12 7.73478 11.8946 7.48043 11.7071 7.29289C11.5196 7.10536 11.2652 7 11 7H9V5Z"
        fill="#006BFF"
      />
    </svg>
  ),

  donate: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C10.81 0 3.33333 7.47667 3.33333 16.6667C3.33333 25.8567 10.81 33.3333 20 33.3333C29.19 33.3333 36.6667 25.8567 36.6667 16.6667C36.6667 7.47667 29.19 0 20 0ZM17.74 14.6017L22.8083 15.445C25.045 15.8183 26.6667 17.735 26.6667 20C26.6667 22.7567 24.4233 25 21.6667 25V26.6667H18.3333V25C15.5767 25 13.3333 22.7567 13.3333 20H16.6667C16.6667 20.92 17.415 21.6667 18.3333 21.6667H21.6667C22.585 21.6667 23.3333 20.92 23.3333 20C23.3333 19.3683 22.8817 18.8367 22.26 18.7317L17.1917 17.8883C14.955 17.515 13.3333 15.5983 13.3333 13.3333C13.3333 10.5767 15.5767 8.33333 18.3333 8.33333V6.66667H21.6667V8.33333C24.4233 8.33333 26.6667 10.5767 26.6667 13.3333H23.3333C23.3333 12.4133 22.585 11.6667 21.6667 11.6667H18.3333C17.415 11.6667 16.6667 12.4133 16.6667 13.3333C16.6667 13.965 17.1183 14.4967 17.74 14.6017ZM40 34.1667C40 37.3883 37.3883 40 34.1667 40H5.83333C2.61167 40 0 37.3883 0 34.1667C0 31.5833 1.69 29.4183 4.015 28.6517C7.66333 33.51 13.455 36.6667 20 36.6667C26.545 36.6667 32.335 33.51 35.985 28.6517C38.3117 29.4183 40 31.585 40 34.1667Z"
        fill="#006BFF"
      />
    </svg>
  ),

  graphics: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 40C17.25 40 15 37.75 15 35V5C15 2.25 17.25 0 20 0C22.75 0 25 2.25 25 5V35C25 37.75 22.75 40 20 40ZM35 40C32.25 40 30 37.75 30 35V15C30 12.25 32.25 10 35 10C37.75 10 40 12.25 40 15V35C40 37.75 37.75 40 35 40ZM5 40C2.25 40 0 37.75 0 35V25C0 22.25 2.25 20 5 20C7.75 20 10 22.25 10 25V35C10 37.75 7.75 40 5 40Z"
        fill="#006BFF"
      />
    </svg>
  ),

  robot: (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.332 40H3.66536C2.74536 40 1.9987 39.255 1.9987 38.3333C1.9987 32.8183 6.4837 28.3333 11.9987 28.3333H21.9987C27.5137 28.3333 31.9987 32.8183 31.9987 38.3333C31.9987 39.255 31.252 40 30.332 40ZM31.1654 10H30.332C30.332 6.32333 27.342 3.33333 23.6654 3.33333H18.6654V1.66667C18.6654 0.745 17.9187 0 16.9987 0C16.0787 0 15.332 0.745 15.332 1.66667V3.33333H10.332C6.65536 3.33333 3.66536 6.32333 3.66536 10H2.83203C1.4537 10 0.332031 11.1217 0.332031 12.5V15.8333C0.332031 17.2117 1.4537 18.3333 2.83203 18.3333H3.66536C3.66536 22.01 6.65536 25 10.332 25H23.6654C27.342 25 30.332 22.01 30.332 18.3333H31.1654C32.5437 18.3333 33.6654 17.2117 33.6654 15.8333V12.5C33.6654 11.1217 32.5437 10 31.1654 10ZM12.832 16.6667C11.452 16.6667 10.332 15.5467 10.332 14.1667C10.332 12.7867 11.452 11.6667 12.832 11.6667C14.212 11.6667 15.332 12.7867 15.332 14.1667C15.332 15.5467 14.212 16.6667 12.832 16.6667ZM21.1654 16.6667C19.7854 16.6667 18.6654 15.5467 18.6654 14.1667C18.6654 12.7867 19.7854 11.6667 21.1654 11.6667C22.5454 11.6667 23.6654 12.7867 23.6654 14.1667C23.6654 15.5467 22.5454 16.6667 21.1654 16.6667Z"
        fill="#006BFF"
      />
    </svg>
  ),

  clock: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866572 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9943 14.6974 37.8853 9.61368 34.1358 5.8642C30.3863 2.11471 25.3026 0.00573514 20 0ZM21.6667 19.7983C21.6669 20.0809 21.5952 20.3588 21.4585 20.606C21.3217 20.8532 21.1244 21.0616 20.885 21.2117L14.485 25.2117C14.299 25.3279 14.0919 25.4063 13.8755 25.4425C13.6592 25.4787 13.4378 25.4719 13.2241 25.4225C13.0103 25.3732 12.8084 25.2822 12.6299 25.1548C12.4513 25.0274 12.2996 24.866 12.1833 24.68C12.0671 24.494 11.9887 24.2869 11.9525 24.0705C11.9163 23.8541 11.9231 23.6328 11.9725 23.4191C12.0219 23.2053 12.1128 23.0034 12.2402 22.8248C12.3676 22.6463 12.529 22.4946 12.715 22.3783L18.3333 18.875V11.6667C18.3333 11.2246 18.5089 10.8007 18.8215 10.4882C19.1341 10.1756 19.558 10 20 10C20.442 10 20.866 10.1756 21.1785 10.4882C21.4911 10.8007 21.6667 11.2246 21.6667 11.6667V19.7983Z"
        fill="#A88EFF"
      />
    </svg>
  ),

  hourglass: (
    <svg
      width="30"
      height="40"
      viewBox="0 0 30 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9296 7.63188C30.2113 5.74521 29.6529 3.82854 28.3996 2.37354C27.1246 0.893542 25.2763 0.046875 23.3263 0.046875H6.67628C4.72628 0.046875 2.87794 0.896875 1.60461 2.37687C0.34961 3.83354 -0.207056 5.75021 0.0762774 7.63854C0.752944 12.1369 3.21794 16.3019 7.41128 20.0452C3.21628 23.7885 0.751277 27.9535 0.0762774 32.4519C-0.207056 34.3402 0.351277 36.2569 1.60461 37.7135C2.87794 39.1952 4.72794 40.0419 6.67628 40.0419H23.3263C25.2763 40.0419 27.1246 39.1952 28.3996 37.7152C29.6529 36.2602 30.2113 34.3435 29.9296 32.4585C29.2579 27.9752 26.7896 23.8069 22.5863 20.0435C26.7896 16.2802 29.2579 12.1135 29.9296 7.63188ZM24.8779 7.33687C23.2379 11.3902 19.7929 14.7069 17.1963 16.7735L16.0463 17.6919C15.4379 18.1752 14.5796 18.1752 13.9713 17.6952L12.7979 16.7635C10.2029 14.7119 6.76628 11.4102 5.12294 7.33687C4.91461 6.82188 4.97794 6.24021 5.28628 5.78021C5.59628 5.32188 6.11461 5.04688 6.66794 5.04688H23.3346C23.8896 5.04688 24.4079 5.32021 24.7163 5.78021C25.0263 6.23854 25.0863 6.82354 24.8779 7.33687ZM15.1196 14.1669L15.0029 14.2602L14.8663 14.1519C13.1213 12.7719 10.9496 10.7702 9.41461 8.38188H20.5846C19.0446 10.7635 16.8696 12.7752 15.1213 14.1685L15.1196 14.1669Z"
        fill="#A88EFF"
      />
    </svg>
  ),

  crown: (
    <svg
      width="40"
      height="33"
      viewBox="0 0 40 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.9433 3.60939C37.3343 3.3557 36.6636 3.28902 36.0165 3.41783C35.3695 3.54665 34.7754 3.86513 34.31 4.33273L30 8.64273L22.3567 0.999392C21.7316 0.374489 20.8839 0.0234375 20 0.0234375C19.1161 0.0234375 18.2684 0.374489 17.6433 0.999392L10 8.64273L5.69 4.33273C5.22383 3.86669 4.62995 3.54934 3.98344 3.42078C3.33693 3.29222 2.66682 3.35823 2.05782 3.61047C1.44882 3.8627 0.928276 4.28983 0.561995 4.83786C0.195714 5.3859 0.000140748 6.03023 0 6.68939L0 24.3327C0.00264643 26.5421 0.88147 28.6601 2.4437 30.2224C4.00593 31.7846 6.12401 32.6634 8.33333 32.6661H31.6667C33.876 32.6634 35.9941 31.7846 37.5563 30.2224C39.1185 28.6601 39.9974 26.5421 40 24.3327V6.68939C40.0002 6.03017 39.8049 5.38571 39.4388 4.83748C39.0727 4.28925 38.5523 3.86187 37.9433 3.60939Z"
        fill="#A88EFF"
      />
    </svg>
  ),

  eyes: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.86879C1.06812 2.46741 4.24565 0 8 0C11.7543 0 14.9319 2.46741 16 5.86879C14.9319 9.27017 11.7543 11.7376 8 11.7376C4.24565 11.7376 1.06812 9.27017 0 5.86879ZM11.3536 5.86879C11.3536 6.75822 11.0003 7.61122 10.3714 8.24014C9.74243 8.86906 8.88943 9.22239 8 9.22239C7.11057 9.22239 6.25757 8.86906 5.62865 8.24014C4.99973 7.61122 4.64641 6.75822 4.64641 5.86879C4.64641 4.97936 4.99973 4.12636 5.62865 3.49744C6.25757 2.86852 7.11057 2.5152 8 2.5152C8.88943 2.5152 9.74243 2.86852 10.3714 3.49744C11.0003 4.12636 11.3536 4.97936 11.3536 5.86879Z"
        fill="#F5EBFF"
      />
    </svg>
  ),

  notEyes: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.521 0.298743C18.3335 0.107458 18.0792 0 17.814 0C17.5488 0 17.2945 0.107458 17.107 0.298743L1.48 16.2457C1.38449 16.3399 1.30831 16.4524 1.2559 16.5769C1.20349 16.7014 1.1759 16.8353 1.17475 16.9708C1.1736 17.1063 1.1989 17.2406 1.24918 17.366C1.29946 17.4914 1.37371 17.6053 1.4676 17.7011C1.5615 17.797 1.67315 17.8727 1.79605 17.924C1.91894 17.9753 2.05062 18.0011 2.1834 18C2.31618 17.9988 2.4474 17.9706 2.5694 17.9172C2.69141 17.8637 2.80175 17.786 2.894 17.6885L18.52 1.74151C18.7075 1.55017 18.8128 1.29069 18.8128 1.02013C18.8128 0.749569 18.7085 0.490087 18.521 0.298743ZM3.108 12.5633L5.668 9.95122C5.59501 9.63757 5.5571 9.31649 5.555 8.99413C5.555 6.56673 7.545 4.59746 10 4.59746C10.286 4.59746 10.564 4.63011 10.835 4.68113L12.038 3.45467C11.3644 3.3408 10.6828 3.2828 10 3.28121C3.44 3.28019 0 8.20949 0 8.99413C0 9.42574 1.057 11.1277 3.108 12.5633ZM16.895 5.42802L14.333 8.04011C14.402 8.34825 14.444 8.66558 14.444 8.99413C14.444 11.4215 12.455 13.3888 10 13.3888C9.716 13.3888 9.44 13.3561 9.171 13.3061L7.967 14.5336C8.609 14.6397 9.283 14.707 10 14.707C16.56 14.707 20 9.77572 20 8.99413C20 8.56151 18.944 6.86161 16.895 5.42802Z"
        fill="#495E7A"
      />
    </svg>
  ),

  dotsAround: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM5 7H3V9H5V7ZM13 7H11V9H13V7ZM7 7H9V9H7V7Z"
        fill="#BFB4E0"
      />
    </svg>
  ),

  plus: (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C8.30311 0 8.59379 0.13016 8.80812 0.361845C9.02245 0.593531 9.14286 0.907764 9.14286 1.23542V7.4125H14.8571C15.1602 7.4125 15.4509 7.54266 15.6653 7.77435C15.8796 8.00603 16 8.32027 16 8.64792C16 8.97557 15.8796 9.28981 15.6653 9.52149C15.4509 9.75318 15.1602 9.88334 14.8571 9.88334H9.14286V16.0604C9.14286 16.3881 9.02245 16.7023 8.80812 16.934C8.59379 17.1657 8.30311 17.2958 8 17.2958C7.6969 17.2958 7.40621 17.1657 7.19188 16.934C6.97755 16.7023 6.85714 16.3881 6.85714 16.0604V9.88334H1.14286C0.839753 9.88334 0.549062 9.75318 0.334735 9.52149C0.120408 9.28981 0 8.97557 0 8.64792C0 8.32027 0.120408 8.00603 0.334735 7.77435C0.549062 7.54266 0.839753 7.4125 1.14286 7.4125H6.85714V1.23542C6.85714 0.907764 6.97755 0.593531 7.19188 0.361845C7.40621 0.13016 7.6969 0 8 0Z"
        fill="#006BFF"
      />
    </svg>
  ),

  calendar: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_14220)">
        <rect width="40" height="40" fill="none" />
        <path
          d="M0 31.6666C0.00264643 33.876 0.88147 35.994 2.4437 37.5563C4.00593 39.1185 6.12401 39.9973 8.33333 40H31.6667C33.876 39.9973 35.9941 39.1185 37.5563 37.5563C39.1185 35.994 39.9974 33.876 40 31.6666V16.6666H0V31.6666ZM28.3333 24.1666C28.8278 24.1666 29.3111 24.3132 29.7223 24.588C30.1334 24.8627 30.4538 25.2531 30.643 25.7099C30.8322 26.1667 30.8818 26.6694 30.7853 27.1544C30.6888 27.6393 30.4507 28.0848 30.1011 28.4344C29.7515 28.784 29.306 29.0221 28.8211 29.1186C28.3361 29.2151 27.8334 29.1655 27.3766 28.9763C26.9198 28.7871 26.5294 28.4667 26.2547 28.0556C25.98 27.6444 25.8333 27.1611 25.8333 26.6666C25.8333 26.0036 26.0967 25.3677 26.5656 24.8989C27.0344 24.43 27.6703 24.1666 28.3333 24.1666ZM20 24.1666C20.4945 24.1666 20.9778 24.3132 21.3889 24.588C21.8 24.8627 22.1205 25.2531 22.3097 25.7099C22.4989 26.1667 22.5484 26.6694 22.452 27.1544C22.3555 27.6393 22.1174 28.0848 21.7678 28.4344C21.4181 28.784 20.9727 29.0221 20.4877 29.1186C20.0028 29.2151 19.5001 29.1655 19.0433 28.9763C18.5865 28.7871 18.196 28.4667 17.9213 28.0556C17.6466 27.6444 17.5 27.1611 17.5 26.6666C17.5 26.0036 17.7634 25.3677 18.2322 24.8989C18.7011 24.43 19.337 24.1666 20 24.1666ZM11.6667 24.1666C12.1611 24.1666 12.6445 24.3132 13.0556 24.588C13.4667 24.8627 13.7871 25.2531 13.9764 25.7099C14.1656 26.1667 14.2151 26.6694 14.1186 27.1544C14.0222 27.6393 13.7841 28.0848 13.4344 28.4344C13.0848 28.784 12.6393 29.0221 12.1544 29.1186C11.6694 29.2151 11.1668 29.1655 10.71 28.9763C10.2531 28.7871 9.8627 28.4667 9.58799 28.0556C9.31329 27.6444 9.16667 27.1611 9.16667 26.6666C9.16667 26.0036 9.43006 25.3677 9.8989 24.8989C10.3677 24.43 11.0036 24.1666 11.6667 24.1666Z"
          fill="#006BFF"
        />
        <path
          d="M31.6667 3.33333H30V1.66667C30 1.22464 29.8244 0.800716 29.5118 0.488155C29.1993 0.175595 28.7754 0 28.3333 0C27.8913 0 27.4674 0.175595 27.1548 0.488155C26.8423 0.800716 26.6667 1.22464 26.6667 1.66667V3.33333H13.3333V1.66667C13.3333 1.22464 13.1577 0.800716 12.8452 0.488155C12.5326 0.175595 12.1087 0 11.6667 0C11.2246 0 10.8007 0.175595 10.4882 0.488155C10.1756 0.800716 10 1.22464 10 1.66667V3.33333H8.33333C6.12401 3.33598 4.00593 4.2148 2.4437 5.77703C0.88147 7.33926 0.00264643 9.45734 0 11.6667L0 13.3333H40V11.6667C39.9974 9.45734 39.1185 7.33926 37.5563 5.77703C35.9941 4.2148 33.876 3.33598 31.6667 3.33333Z"
          fill="#006BFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_14220">
          <rect width="40" height="40" fill="none" />
        </clipPath>
      </defs>
    </svg>
  ),

  graphic: (
    <svg viewBox="0 0 188 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.2"
        d="M22.6746 17.6318C16.535 24.5965 5.00004 29.9515 0 31.7584V56.003H186.978V7.44756C158.722 7.44756 158.373 49.1702 142.327 49.1702C126.28 49.1702 125.582 25.5164 117.559 25.5164C109.536 25.5164 111.629 38.3289 93.1403 36.8505C74.6518 35.3722 65.5819 20.7528 54.419 7.44756C43.3163 -5.78605 30.488 8.76754 22.799 17.4907L22.6746 17.6318Z"
        fill="#7A9BFF"
        stroke="#7A9BFF"
        strokeWidth="3"
      />
    </svg>
  ),

  pix: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.7923 27.275C27.1171 27.2765 26.4482 27.1443 25.8244 26.886C25.2005 26.6277 24.6339 26.2484 24.1573 25.77L18.9073 20.52C18.7215 20.3435 18.4749 20.245 18.2186 20.245C17.9622 20.245 17.7157 20.3435 17.5298 20.52L12.2598 25.79C11.7834 26.2686 11.2169 26.648 10.593 26.9064C9.96906 27.1647 9.30013 27.2968 8.62484 27.295H7.58984L14.2398 33.945C16.3148 36.02 19.6823 36.02 21.7573 33.945L28.4248 27.275H27.7923ZM8.62484 8.70501C9.99984 8.70501 11.2898 9.24001 12.2598 10.21L17.5298 15.48C17.6204 15.5707 17.728 15.6427 17.8464 15.6918C17.9648 15.7409 18.0917 15.7662 18.2198 15.7662C18.348 15.7662 18.4749 15.7409 18.5933 15.6918C18.7117 15.6427 18.8193 15.5707 18.9098 15.48L24.1598 10.23C24.6359 9.75171 25.2021 9.37246 25.8255 9.11415C26.449 8.85583 27.1175 8.72358 27.7923 8.72501H28.4248L21.7573 2.05751C20.7602 1.06108 19.4082 0.501343 17.9986 0.501343C16.5889 0.501343 15.237 1.06108 14.2398 2.05751L7.58984 8.70751L8.62484 8.70501Z"
        fill="#006BFF"
      />
      <path
        d="M33.9427 14.24L29.9127 10.21C29.8222 10.2472 29.7255 10.2667 29.6277 10.2675H27.7952C26.8477 10.2675 25.9202 10.6525 25.2527 11.3225L20.0027 16.5725C19.7692 16.8072 19.4917 16.9935 19.186 17.1205C18.8803 17.2476 18.5525 17.3131 18.2215 17.3131C17.8904 17.3131 17.5626 17.2476 17.2569 17.1205C16.9512 16.9935 16.6737 16.8072 16.4402 16.5725L11.1702 11.3C10.4941 10.6267 9.57944 10.2475 8.62521 10.245H6.37521C6.28194 10.2443 6.18959 10.2265 6.10271 10.1925L2.05771 14.24C-0.0172851 16.315 -0.0172851 19.6825 2.05771 21.76L6.10271 25.805C6.18863 25.7704 6.28012 25.7518 6.37271 25.75H8.62521C9.57522 25.75 10.5002 25.3675 11.1702 24.6975L16.4377 19.425C16.9183 18.9674 17.5566 18.7121 18.2202 18.7121C18.8839 18.7121 19.5221 18.9674 20.0027 19.425L25.2527 24.675C25.9202 25.345 26.8477 25.7275 27.7952 25.7275H29.6277C29.7277 25.7275 29.8252 25.7525 29.9127 25.7875L33.9427 21.7575C36.0177 19.6825 36.0177 16.315 33.9427 14.24Z"
        fill="#006BFF"
      />
    </svg>
  ),

  cardPayment: (
    <svg
      width="40"
      height="30"
      viewBox="0 0 40 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.6667 0H8.33333C6.12401 0.00264643 4.00593 0.88147 2.4437 2.4437C0.88147 4.00593 0.00264643 6.12401 0 8.33333H40C39.9974 6.12401 39.1185 4.00593 37.5563 2.4437C35.9941 0.88147 33.876 0.00264643 31.6667 0Z"
        fill="#006BFF"
      />
      <path
        d="M0 21.6666C0.00264643 23.876 0.88147 25.994 2.4437 27.5563C4.00593 29.1185 6.12401 29.9973 8.33333 30H31.6667C33.876 29.9973 35.9941 29.1185 37.5563 27.5563C39.1185 25.994 39.9974 23.876 40 21.6666V11.6666H0V21.6666ZM11.6667 20.8333C11.6667 21.3277 11.52 21.8111 11.2453 22.2222C10.9706 22.6333 10.5802 22.9538 10.1234 23.143C9.66656 23.3322 9.16389 23.3817 8.67894 23.2853C8.19399 23.1888 7.74853 22.9507 7.3989 22.6011C7.04927 22.2514 6.81117 21.806 6.7147 21.321C6.61824 20.8361 6.66775 20.3334 6.85697 19.8766C7.04619 19.4198 7.36662 19.0293 7.77774 18.7546C8.18886 18.4799 8.67221 18.3333 9.16667 18.3333C9.82971 18.3333 10.4656 18.5967 10.9344 19.0655C11.4033 19.5344 11.6667 20.1703 11.6667 20.8333Z"
        fill="#006BFF"
      />
    </svg>
  ),

  cardPaymentBorder: (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.55556H21M5.44444 12.1111H6.55556M11 12.1111H12.1111M4.33333 16.5556H17.6667C18.5507 16.5556 19.3986 16.2044 20.0237 15.5792C20.6488 14.9541 21 14.1063 21 13.2222V4.33333C21 3.44928 20.6488 2.60143 20.0237 1.97631C19.3986 1.35119 18.5507 1 17.6667 1H4.33333C3.44928 1 2.60143 1.35119 1.97631 1.97631C1.35119 2.60143 1 3.44928 1 4.33333V13.2222C1 14.1063 1.35119 14.9541 1.97631 15.5792C2.60143 16.2044 3.44928 16.5556 4.33333 16.5556Z"
        stroke="#495E7A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  arrowRight: (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L8 8L1 15"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  key: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.6481 21.1667V16.6667C26.6481 16.2247 26.8237 15.8007 27.1363 15.4882C27.4488 15.1756 27.8728 15 28.3148 15H29.9815C30.4235 15 30.8474 14.8244 31.16 14.5119C31.4725 14.1993 31.6481 13.7754 31.6481 13.3334V11.6667C31.6481 11.2247 31.8237 10.8007 32.1363 10.4882C32.4488 10.1756 32.8728 10 33.3148 10H37.7898C38.1149 9.99845 38.4327 9.90331 38.7052 9.72599C38.9777 9.54866 39.1934 9.29664 39.3265 9.00003C39.8894 7.76032 40.1059 6.39128 39.9531 5.03836C39.7627 3.62974 39.0632 2.33956 37.9867 1.41135C36.9102 0.483133 35.5311 -0.0188936 34.1098 2.77169e-05C32.1044 0.000154547 30.1811 0.796911 28.7631 2.21503L15.5831 15.3917C13.4586 14.8398 11.225 14.8674 9.1148 15.4717C6.21156 16.2927 3.70322 18.136 2.05264 20.6615C0.402052 23.1871 -0.279384 26.2244 0.134071 29.213C0.547527 32.2016 2.02797 34.9399 4.30222 36.9224C6.57648 38.905 9.49105 39.9981 12.5081 40C12.9446 39.9996 13.3807 39.9768 13.8148 39.9317C16.2984 39.6613 18.6447 38.6557 20.5534 37.0437C22.462 35.4317 23.846 33.2867 24.5281 30.8834C25.1343 28.7739 25.1614 26.5402 24.6065 24.4167L25.6898 23.3334C26.2659 22.7543 26.6073 21.9825 26.6481 21.1667ZM9.16647 33.3334C8.67201 33.3334 8.18866 33.1867 7.77754 32.912C7.36642 32.6373 7.04599 32.2469 6.85677 31.7901C6.66755 31.3333 6.61804 30.8306 6.7145 30.3456C6.81097 29.8607 7.04907 29.4152 7.3987 29.0656C7.74833 28.716 8.19379 28.4779 8.67874 28.3814C9.16369 28.2849 9.66636 28.3344 10.1232 28.5237C10.58 28.7129 10.9704 29.0333 11.2451 29.4444C11.5198 29.8556 11.6665 30.3389 11.6665 30.8334C11.6665 31.4964 11.4031 32.1323 10.9342 32.6011C10.4654 33.07 9.82951 33.3334 9.16647 33.3334Z"
        fill="#006BFF"
      />
    </svg>
  ),

  email: (
    <svg
      width="40"
      height="38"
      viewBox="0 0 40 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.9233 8.23669L25.8933 22.2667C24.329 23.8271 22.2096 24.7034 20 24.7034C17.7904 24.7034 15.671 23.8271 14.1067 22.2667L0.0766667 8.23669C0.0533333 8.50003 0 8.73836 0 9.00003V29C0.00264643 31.2094 0.88147 33.3274 2.4437 34.8897C4.00593 36.4519 6.12401 37.3307 8.33333 37.3334H31.6667C33.876 37.3307 35.9941 36.4519 37.5563 34.8897C39.1185 33.3274 39.9974 31.2094 40 29V9.00003C40 8.73836 39.9467 8.50003 39.9233 8.23669Z"
        fill="#6933FF"
      />
      <path
        d="M23.5369 19.91L38.7602 4.68496C38.0228 3.46216 36.9827 2.45002 35.7402 1.74618C34.4977 1.04233 33.0949 0.670527 31.6669 0.666626H8.33357C6.9056 0.670527 5.50274 1.04233 4.26028 1.74618C3.01782 2.45002 1.9777 3.46216 1.24023 4.68496L16.4636 19.91C17.4029 20.8455 18.6745 21.3707 20.0002 21.3707C21.3259 21.3707 22.5976 20.8455 23.5369 19.91Z"
        fill="#6933FF"
      />
    </svg>
  ),

  fingerprint: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_14031)">
        <rect width="40" height="40" fill="white" />
        <path
          d="M9.95333 37.1418C9.58902 37.1416 9.23479 37.0222 8.94483 36.8016C8.65487 36.581 8.44517 36.2715 8.34781 35.9205C8.25045 35.5694 8.2708 35.1961 8.40574 34.8577C8.54069 34.5193 8.78279 34.2345 9.095 34.0468C15 30.5001 15 22.8834 15 18.3334C15 17.0073 15.5268 15.7356 16.4645 14.7979C17.4021 13.8602 18.6739 13.3334 20 13.3334C21.3261 13.3334 22.5979 13.8602 23.5355 14.7979C24.4732 15.7356 25 17.0073 25 18.3334C25 18.7754 24.8244 19.1994 24.5118 19.5119C24.1993 19.8245 23.7754 20.0001 23.3333 20.0001C22.8913 20.0001 22.4674 19.8245 22.1548 19.5119C21.8423 19.1994 21.6667 18.7754 21.6667 18.3334C21.6667 17.8914 21.4911 17.4675 21.1785 17.1549C20.866 16.8423 20.442 16.6668 20 16.6668C19.558 16.6668 19.1341 16.8423 18.8215 17.1549C18.5089 17.4675 18.3333 17.8914 18.3333 18.3334C18.3333 23.2451 18.3333 32.3901 10.81 36.9051C10.5511 37.0601 10.255 37.1419 9.95333 37.1418ZM18.225 39.5101C22.0283 35.6768 24.25 30.2868 24.8267 23.4751C24.8461 23.2566 24.8222 23.0364 24.7564 22.8271C24.6905 22.6179 24.584 22.4237 24.443 22.2557C24.3019 22.0877 24.1291 21.9492 23.9344 21.8481C23.7397 21.747 23.5269 21.6854 23.3083 21.6668C23.0896 21.6443 22.8686 21.6661 22.6586 21.7309C22.4485 21.7957 22.2535 21.9021 22.0854 22.0438C21.9173 22.1854 21.7794 22.3595 21.68 22.5556C21.5806 22.7517 21.5216 22.9657 21.5067 23.1851C20.9883 29.2801 19.1417 33.8518 15.86 37.1534C15.5484 37.467 15.3741 37.8916 15.3755 38.3337C15.3769 38.7758 15.5539 39.1993 15.8675 39.5109C16.1811 39.8225 16.6057 39.9968 17.0478 39.9954C17.4899 39.994 17.9134 39.817 18.225 39.5034V39.5101ZM26.8917 39.2001C27.9026 37.5203 28.7445 35.7444 29.405 33.8984C29.5431 33.4856 29.5141 33.0351 29.3244 32.6433C29.1346 32.2515 28.7991 31.9495 28.3895 31.8019C27.98 31.6543 27.529 31.6728 27.1329 31.8534C26.7368 32.034 26.4271 32.3624 26.27 32.7684C25.6832 34.4052 24.9362 35.9801 24.04 37.4701C23.9264 37.6573 23.8508 37.8651 23.8175 38.0816C23.7842 38.298 23.7939 38.5189 23.846 38.7317C23.898 38.9444 23.9915 39.1448 24.121 39.3214C24.2506 39.498 24.4136 39.6473 24.6008 39.7609C24.979 39.9903 25.4328 40.0601 25.8624 39.9549C26.0751 39.9029 26.2755 39.8094 26.4521 39.6799C26.6287 39.5504 26.7781 39.3873 26.8917 39.2001ZM30.8333 28.6518C31.4508 25.2482 31.7299 21.7919 31.6667 18.3334C31.6651 15.9722 30.9471 13.6671 29.6076 11.7227C28.2681 9.77824 26.3701 8.286 24.1645 7.44315C21.9589 6.60031 19.5495 6.44655 17.2546 7.00218C14.9597 7.55781 12.8875 8.79669 11.3117 10.5551C11.1582 10.7168 11.0387 10.9076 10.9603 11.1162C10.8819 11.3249 10.8461 11.5472 10.8551 11.7699C10.8642 11.9926 10.9178 12.2113 11.0128 12.4129C11.1078 12.6146 11.2423 12.7951 11.4083 12.9439C11.5743 13.0926 11.7685 13.2066 11.9794 13.2789C12.1902 13.3513 12.4134 13.3806 12.6358 13.3652C12.8582 13.3498 13.0752 13.2899 13.274 13.1891C13.4728 13.0883 13.6494 12.9487 13.7933 12.7784C14.9188 11.5222 16.399 10.6371 18.0382 10.24C19.6774 9.84297 21.3985 9.95265 22.9741 10.5546C24.5496 11.1565 25.9055 12.2224 26.8624 13.6113C27.8193 15.0002 28.3322 16.6468 28.3333 18.3334C28.3948 21.5781 28.1369 24.8209 27.5633 28.0151C27.4792 28.4487 27.5706 28.898 27.8175 29.2642C28.0643 29.6305 28.4465 29.8838 28.88 29.9684C28.9859 29.9896 29.0937 30.0002 29.2017 30.0001C29.5877 29.9991 29.9614 29.8641 30.259 29.6182C30.5566 29.3723 30.7596 29.0307 30.8333 28.6518ZM11.6667 18.3334C11.6662 17.8682 11.7047 17.4038 11.7817 16.9451C11.8314 16.7242 11.8357 16.4956 11.7942 16.273C11.7526 16.0505 11.6662 15.8387 11.5401 15.6507C11.4141 15.4626 11.251 15.3022 11.0609 15.1793C10.8709 15.0563 10.6577 14.9734 10.4345 14.9355C10.2113 14.8977 9.98273 14.9057 9.76272 14.9591C9.54272 15.0124 9.3359 15.1101 9.15488 15.246C8.97386 15.382 8.82243 15.5534 8.70984 15.7498C8.59725 15.9462 8.52585 16.1635 8.5 16.3884C8.38998 17.0309 8.33423 17.6816 8.33333 18.3334C8.33333 26.0751 6.09 30.0001 1.66667 30.0001C1.22464 30.0001 0.800716 30.1757 0.488155 30.4882C0.175595 30.8008 0 31.2247 0 31.6668C0 32.1088 0.175595 32.5327 0.488155 32.8453C0.800716 33.1578 1.22464 33.3334 1.66667 33.3334C8.115 33.3334 11.6667 28.0001 11.6667 18.3334ZM34.5 39.0234C37.2428 32.4803 38.55 25.4249 38.3333 18.3334C38.341 15.565 37.7138 12.8316 36.5 10.3434C36.4042 10.1464 36.2706 9.97024 36.1068 9.8249C35.9429 9.67955 35.7521 9.56791 35.5451 9.49633C35.3381 9.42475 35.119 9.39464 34.9004 9.40773C34.6817 9.42081 34.4678 9.47683 34.2708 9.57259C34.0739 9.66834 33.8977 9.80196 33.7523 9.96581C33.607 10.1297 33.4953 10.3205 33.4237 10.5275C33.3522 10.7345 33.3221 10.9536 33.3351 11.1722C33.3482 11.3909 33.4042 11.6048 33.5 11.8018C34.4917 13.836 35.0048 16.0703 35 18.3334C35.2098 24.948 34.0058 31.5313 31.4683 37.6434C31.378 37.843 31.3279 38.0584 31.3209 38.2774C31.3139 38.4964 31.3501 38.7146 31.4275 38.9195C31.5049 39.1245 31.622 39.3122 31.7719 39.4718C31.9219 39.6315 32.102 39.76 32.3017 39.8501C32.5175 39.9494 32.7524 40.0005 32.99 40.0001C33.3087 39.9987 33.6204 39.906 33.888 39.7329C34.1557 39.5598 34.368 39.3136 34.5 39.0234ZM5 23.3334V18.3334C5.00441 14.3565 6.58618 10.5438 9.39827 7.73169C12.2104 4.9196 16.0231 3.33783 20 3.33342C23.2473 3.3226 26.4087 4.37639 29 6.33342C29.3536 6.59864 29.7981 6.71251 30.2357 6.65C30.6733 6.58749 31.0681 6.35371 31.3333 6.00009C31.5986 5.64646 31.7124 5.20197 31.6499 4.76438C31.5874 4.3268 31.3536 3.93197 31 3.66675C27.8323 1.27579 23.9688 -0.012058 20 8.50908e-05C15.1395 0.00581921 10.4796 1.9392 7.04271 5.37613C3.60578 8.81305 1.6724 13.4729 1.66667 18.3334V23.3334C1.66667 23.7754 1.84226 24.1994 2.15482 24.5119C2.46738 24.8245 2.89131 25.0001 3.33333 25.0001C3.77536 25.0001 4.19928 24.8245 4.51185 24.5119C4.82441 24.1994 5 23.7754 5 23.3334Z"
          fill="#006BFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_14031">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  circleXMark: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C8.97167 0 0 8.97167 0 20C0 31.0283 8.97167 40 20 40C31.0283 40 40 31.0283 40 20C40 8.97167 31.0283 0 20 0ZM26.1783 23.8217C26.83 24.4733 26.83 25.5267 26.1783 26.1783C25.8533 26.5033 25.4267 26.6667 25 26.6667C24.5733 26.6667 24.1467 26.5033 23.8217 26.1783L20 22.3567L16.1783 26.1783C15.8533 26.5033 15.4267 26.6667 15 26.6667C14.5733 26.6667 14.1467 26.5033 13.8217 26.1783C13.17 25.5267 13.17 24.4733 13.8217 23.8217L17.6433 20L13.8217 16.1783C13.17 15.5267 13.17 14.4733 13.8217 13.8217C14.4733 13.17 15.5267 13.17 16.1783 13.8217L20 17.6433L23.8217 13.8217C24.4733 13.17 25.5267 13.17 26.1783 13.8217C26.83 14.4733 26.83 15.5267 26.1783 16.1783L22.3567 20L26.1783 23.8217Z"
        fill="#006BFF"
      />
    </svg>
  ),

  eye: (
    <svg viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 9C10.5304 9 11.0391 8.78929 11.4142 8.41421C11.7893 8.03914 12 7.53043 12 7C12 6.46957 11.7893 5.96086 11.4142 5.58579C11.0391 5.21071 10.5304 5 10 5C9.46957 5 8.96086 5.21071 8.58579 5.58579C8.21071 5.96086 8 6.46957 8 7C8 7.53043 8.21071 8.03914 8.58579 8.41421C8.96086 8.78929 9.46957 9 10 9Z"
        fill="#495E7A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.457031 7C1.73103 2.943 5.52103 0 9.99903 0C14.477 0 18.267 2.943 19.541 7C18.267 11.057 14.477 14 9.99903 14C5.52103 14 1.73103 11.057 0.457031 7ZM13.999 7C13.999 8.06087 13.5776 9.07828 12.8275 9.82843C12.0773 10.5786 11.0599 11 9.99903 11C8.93816 11 7.92075 10.5786 7.1706 9.82843C6.42046 9.07828 5.99903 8.06087 5.99903 7C5.99903 5.93913 6.42046 4.92172 7.1706 4.17157C7.92075 3.42143 8.93816 3 9.99903 3C11.0599 3 12.0773 3.42143 12.8275 4.17157C13.5776 4.92172 13.999 5.93913 13.999 7Z"
        fill="#495E7A"
      />
    </svg>
  ),

  "eye-off": (
    <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.521 0.298743C18.3335 0.107458 18.0792 0 17.814 0C17.5488 0 17.2945 0.107458 17.107 0.298743L1.48 16.2457C1.38449 16.3399 1.30831 16.4524 1.2559 16.5769C1.20349 16.7014 1.1759 16.8353 1.17475 16.9708C1.1736 17.1063 1.1989 17.2406 1.24918 17.366C1.29946 17.4914 1.37371 17.6053 1.4676 17.7011C1.5615 17.797 1.67315 17.8727 1.79605 17.924C1.91894 17.9753 2.05062 18.0011 2.1834 18C2.31618 17.9988 2.4474 17.9706 2.5694 17.9172C2.69141 17.8637 2.80175 17.786 2.894 17.6885L18.52 1.74151C18.7075 1.55017 18.8128 1.29069 18.8128 1.02013C18.8128 0.749569 18.7085 0.490087 18.521 0.298743ZM3.108 12.5633L5.668 9.95122C5.59501 9.63757 5.5571 9.31649 5.555 8.99413C5.555 6.56673 7.545 4.59746 10 4.59746C10.286 4.59746 10.564 4.63011 10.835 4.68113L12.038 3.45467C11.3644 3.3408 10.6828 3.2828 10 3.28121C3.44 3.28019 0 8.20949 0 8.99413C0 9.42574 1.057 11.1277 3.108 12.5633ZM16.895 5.42802L14.333 8.04011C14.402 8.34825 14.444 8.66558 14.444 8.99413C14.444 11.4215 12.455 13.3888 10 13.3888C9.716 13.3888 9.44 13.3561 9.171 13.3061L7.967 14.5336C8.609 14.6397 9.283 14.707 10 14.707C16.56 14.707 20 9.77572 20 8.99413C20 8.56151 18.944 6.86161 16.895 5.42802Z"
        fill="#495E7A"
      />
    </svg>
  ),

  creditCardOutlined: (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.55556H21M5.44444 12.1111H6.55556M11 12.1111H12.1111M4.33333 16.5556H17.6667C18.5507 16.5556 19.3986 16.2044 20.0237 15.5792C20.6488 14.9541 21 14.1063 21 13.2222V4.33333C21 3.44928 20.6488 2.60143 20.0237 1.97631C19.3986 1.35119 18.5507 1 17.6667 1H4.33333C3.44928 1 2.60143 1.35119 1.97631 1.97631C1.35119 2.60143 1 3.44928 1 4.33333V13.2222C1 14.1063 1.35119 14.9541 1.97631 15.5792C2.60143 16.2044 3.44928 16.5556 4.33333 16.5556Z"
        stroke="#495E7A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  universalAccess: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C8.96667 0 0 8.96667 0 20C0 31.0333 8.96667 40 20 40C31.0333 40 40 31.0333 40 20C40 8.96667 31.0333 0 20 0ZM20 6.66667C21.8333 6.66667 23.3333 8.16667 23.3333 10C23.3333 11.8333 21.8333 13.3333 20 13.3333C18.1667 13.3333 16.6667 11.8333 16.6667 10C16.6667 8.16667 18.1667 6.66667 20 6.66667ZM29.0833 14.8167L23.3333 17.6833V23.5667L26.45 29.1667C26.9 29.9667 26.6167 30.9833 25.8 31.4333C25.55 31.5833 25.2667 31.65 24.9833 31.65C24.4 31.65 23.8333 31.3333 23.5333 30.8L20.3 24.9833H19.6833L16.45 30.8C16.15 31.35 15.5833 31.65 15 31.65C14.7167 31.65 14.45 31.5833 14.1833 31.4333C13.3833 30.9833 13.0833 29.9667 13.5333 29.1667L16.65 23.5667V17.6833L10.9 14.8167C10.0833 14.4 9.75 13.4 10.15 12.5833C10.5667 11.7667 11.5667 11.4333 12.3833 11.8333L18.7 14.9833H21.25L27.5667 11.8333C28.3833 11.4167 29.3833 11.75 29.8 12.5833C30.2167 13.4 29.8833 14.4 29.05 14.8167H29.0833Z"
        fill="#006BFF"
      />
    </svg>
  ),

  circleCheck: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C8.97167 0 0 8.97167 0 20C0 31.0283 8.97167 40 20 40C31.0283 40 40 31.0283 40 20C40 8.97167 31.0283 0 20 0ZM19.8483 25.6983C19.2033 26.3433 18.355 26.665 17.5033 26.665C16.6517 26.665 15.795 26.34 15.1433 25.69L10.5067 21.1967L12.8283 18.8017L17.4833 23.3133L27.165 13.8117L29.505 16.1867L19.8483 25.6983Z"
        fill="#006BFF"
      />
    </svg>
  ),

  upload: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 25V31.6667C40 36.2617 36.2617 40 31.6667 40H8.33333C3.73833 40 0 36.2617 0 31.6667V25C0 22.2433 2.24333 20 5 20H10C11.8383 20 13.3333 21.495 13.3333 23.3333C13.3333 25.1717 14.8283 26.6667 16.6667 26.6667H23.3333C25.1717 26.6667 26.6667 25.1717 26.6667 23.3333C26.6667 21.495 28.1617 20 30 20H35C37.7567 20 40 22.2433 40 25ZM14.5117 8.82167L18.3333 5V16.6667C18.3333 17.5883 19.0783 18.3333 20 18.3333C20.9217 18.3333 21.6667 17.5883 21.6667 16.6667V5L25.4883 8.82167C25.8133 9.14667 26.24 9.31 26.6667 9.31C27.0933 9.31 27.52 9.14667 27.845 8.82167C28.4967 8.17 28.4967 7.11667 27.845 6.465L22.3567 0.976667C21.7133 0.333333 20.8683 0.01 20.0233 0.005L20 0L19.9767 0.005C19.13 0.01 18.2867 0.333333 17.6433 0.976667L12.155 6.465C11.5033 7.11667 11.5033 8.17 12.155 8.82167C12.8067 9.47333 13.86 9.47333 14.5117 8.82167Z"
        fill="#A88EFF"
      />
    </svg>
  ),

  trash: (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9987 6.66664H26.832C26.0346 2.7893 22.6238 0.005 18.6653 0H15.332C11.3734 0.005 7.96266 2.7893 7.16531 6.66664H1.99867C1.0782 6.66664 0.332031 7.41281 0.332031 8.33328C0.332031 9.25375 1.0782 10 1.99867 10H3.66531V31.6666C3.67086 36.2667 7.39859 39.9945 11.9987 40H21.9987C26.5988 39.9945 30.3265 36.2667 30.332 31.6666V10H31.9987C32.9191 10 33.6653 9.25383 33.6653 8.33336C33.6653 7.41289 32.9191 6.66664 31.9987 6.66664ZM15.332 28.3334C15.332 29.2538 14.5859 30 13.6654 30C12.7448 30 11.9987 29.2538 11.9987 28.3334V18.3334C11.9987 17.4129 12.7448 16.6667 13.6653 16.6667C14.5858 16.6667 15.332 17.4129 15.332 18.3334V28.3334H15.332ZM21.9987 28.3334C21.9987 29.2538 21.2525 30 20.332 30C19.4116 30 18.6654 29.2538 18.6654 28.3334V18.3334C18.6654 17.4129 19.4116 16.6667 20.332 16.6667C21.2525 16.6667 21.9987 17.4129 21.9987 18.3334V28.3334ZM10.617 6.66664C11.3259 4.67047 13.2137 3.33586 15.332 3.33328H18.6654C20.7837 3.33586 22.6715 4.67047 23.3804 6.66664H10.617Z"
        fill="#A88EFF"
      />
    </svg>
  ),

  chevronLeft: (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63361 17.1337C9.3992 17.3682 9.08131 17.5 8.74985 17.5C8.41839 17.5 8.1005 17.3682 7.86609 17.1337L0.365988 9.62699C0.131646 9.39237 0 9.0742 0 8.74245C0 8.4107 0.131646 8.09253 0.365988 7.85791L7.86609 0.351203C8.10184 0.123302 8.4176 -0.00280327 8.74535 4.72955e-05C9.0731 0.00289787 9.38662 0.134477 9.61838 0.366444C9.85015 0.598411 9.98161 0.912207 9.98446 1.24025C9.98731 1.56828 9.86131 1.88432 9.63361 2.12028L4.26729 7.49133H18.75C19.0815 7.49133 19.3995 7.62314 19.6339 7.85777C19.8683 8.0924 20 8.41063 20 8.74245C20 9.07426 19.8683 9.39249 19.6339 9.62712C19.3995 9.86175 19.0815 9.99356 18.75 9.99356H4.26729L9.63361 15.3646C9.86795 15.5992 9.9996 15.9174 9.9996 16.2491C9.9996 16.5809 9.86795 16.8991 9.63361 17.1337Z"
        fill="#A98FFF"
      />
    </svg>
  ),

  google: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3030_36409)">
        <path
          d="M19.619 10.4437C19.619 9.62427 19.5535 9.02633 19.4117 8.40625H10.1914V12.1046H15.6035C15.4945 13.0237 14.9052 14.4078 13.5958 15.3379L13.5775 15.4617L16.4927 17.7535L16.6947 17.774C18.5497 16.0355 19.619 13.4776 19.619 10.4437Z"
          fill="#4285F4"
        />
        <path
          d="M10.1909 20.19C12.8424 20.19 15.0684 19.3041 16.6943 17.7761L13.5953 15.34C12.7661 15.9268 11.6531 16.3365 10.1909 16.3365C7.59399 16.3365 5.38986 14.5981 4.60414 12.1953L4.48898 12.2052L1.45761 14.5859L1.41797 14.6978C3.03287 17.9532 6.35001 20.19 10.1909 20.19Z"
          fill="#34A853"
        />
        <path
          d="M4.60476 12.1961C4.39744 11.576 4.27746 10.9116 4.27746 10.2251C4.27746 9.53855 4.39744 8.87419 4.59385 8.25412L4.58836 8.12206L1.51901 5.70312L1.41858 5.7516C0.753005 7.10251 0.371094 8.61954 0.371094 10.2251C0.371094 11.8307 0.753005 13.3476 1.41858 14.6985L4.60476 12.1961Z"
          fill="#FBBC05"
        />
        <path
          d="M10.1909 4.11117C12.035 4.11117 13.2789 4.91949 13.9882 5.59499L16.7597 2.84888C15.0575 1.24331 12.8424 0.257812 10.1909 0.257812C6.35001 0.257812 3.03287 2.49453 1.41797 5.74995L4.59324 8.25247C5.38986 5.84964 7.59399 4.11117 10.1909 4.11117Z"
          fill="#EB4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_3030_36409">
          <rect
            width="19.2593"
            height="20"
            fill="white"
            transform="translate(0.371094 0.257812)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  facebook: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3030_36415)">
        <path
          d="M24 12.7578C24 6.13039 18.6274 0.757812 12 0.757812C5.37258 0.757812 0 6.13039 0 12.7578C0 18.7474 4.38823 23.7118 10.125 24.612V16.2266H7.07812V12.7578H10.125V10.1141C10.125 7.10656 11.9165 5.44531 14.6576 5.44531C15.9705 5.44531 17.3438 5.67969 17.3438 5.67969V8.63281H15.8306C14.3399 8.63281 13.875 9.55781 13.875 10.5068V12.7578H17.2031L16.6711 16.2266H13.875V24.612C19.6118 23.7118 24 18.7474 24 12.7578Z"
          fill="#1877F2"
        />
        <path
          d="M16.6711 16.2266L17.2031 12.7578H13.875V10.5068C13.875 9.55781 14.3399 8.63281 15.8306 8.63281H17.3438V5.67969C17.3438 5.67969 15.9705 5.44531 14.6576 5.44531C11.9165 5.44531 10.125 7.10656 10.125 10.1141V12.7578H7.07812V16.2266H10.125V24.612C11.3674 24.8064 12.6326 24.8064 13.875 24.612V16.2266H16.6711Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3030_36415">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.757812)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  apple: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9392 5.94781C15.3172 5.51209 15.6055 5.00598 15.7874 4.45855C15.9693 3.91112 16.0413 3.33314 15.9992 2.75781C14.8386 2.8515 13.7612 3.39737 12.9992 4.27781C12.6343 4.69979 12.3578 5.19069 12.186 5.72146C12.0142 6.25222 11.9507 6.81206 11.9992 7.36781C12.5653 7.37253 13.125 7.24691 13.6348 7.00067C14.1446 6.75443 14.5909 6.39419 14.9392 5.94781ZM17.4592 13.3878C17.4659 12.6215 17.6677 11.8696 18.0456 11.203C18.4236 10.5364 18.9651 9.97707 19.6192 9.57781C19.2064 8.98305 18.6607 8.49265 18.0254 8.14549C17.3901 7.79833 16.6827 7.60397 15.9592 7.57781C14.3992 7.41781 12.9592 8.48781 12.1292 8.48781C11.2992 8.48781 10.1292 7.59781 8.82918 7.61781C7.97931 7.64581 7.1512 7.89359 6.42563 8.337C5.70005 8.78041 5.10179 9.40429 4.68918 10.1478C2.92918 13.2078 4.23918 17.7578 5.99918 20.2278C6.79918 21.4378 7.79918 22.8078 9.11918 22.7578C10.4392 22.7078 10.8692 21.9378 12.3992 21.9378C13.9292 21.9378 14.3992 22.7578 15.6992 22.7278C16.9992 22.6978 17.9192 21.4878 18.7592 20.2778C19.3542 19.3993 19.819 18.4394 20.1392 17.4278C19.3467 17.0898 18.6705 16.5271 18.1942 15.8091C17.7179 15.0912 17.4624 14.2494 17.4592 13.3878Z"
        fill="black"
      />
    </svg>
  ),

  commission: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 5V8.33333C40 11.095 37.7617 13.3333 35 13.3333H33.3333V15C33.3333 17.7617 31.095 20 28.3333 20H21.6667V25.6583L23.825 23.5017C24.4767 22.85 25.53 22.85 26.1817 23.5017C26.8333 24.1533 26.8333 25.2067 26.1817 25.8583L22.0567 29.985C21.49 30.5517 20.7467 30.835 20.0033 30.835C19.26 30.835 18.5167 30.5517 17.9517 29.985L13.825 25.8583C13.1733 25.2067 13.1733 24.1533 13.825 23.5017C14.4767 22.85 15.53 22.85 16.1817 23.5017L18.335 25.655V19.9983H11.6667C8.905 19.9983 6.66667 17.76 6.66667 14.9983V13.3317H5C2.23833 13.3317 0 11.0933 0 8.33167V5C0 2.23833 2.23833 0 5 0H11.6667C14.4283 0 16.6667 2.23833 16.6667 5V8.33333C16.6667 11.095 14.4283 13.3333 11.6667 13.3333H10V15C10 15.92 10.7467 16.6667 11.6667 16.6667H28.3333C29.2533 16.6667 30 15.92 30 15V13.3333H28.3333C25.5717 13.3333 23.3333 11.095 23.3333 8.33333V5C23.3333 2.23833 25.5717 0 28.3333 0H35C37.7617 0 40 2.23833 40 5ZM35 25H29.97C29.895 26.1717 29.4317 27.3233 28.5383 28.2167L24.5717 32.185C23.6383 33.1183 22.4683 33.83 21.1683 34.0633C19.0783 34.4383 17.0417 33.7917 15.5933 32.3417L11.4667 28.215C10.5733 27.3217 10.11 26.17 10.035 24.9983H5C2.23833 24.9983 0 27.2367 0 29.9983V34.9983C0 37.76 2.23833 39.9983 5 39.9983H35C37.7617 39.9983 40 37.76 40 34.9983V29.9983C40 27.2367 37.7617 24.9983 35 24.9983V25Z"
        fill="#006BFF"
      />
    </svg>
  ),

  pyramid: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.978356 30.4C0.480349 31.4164 0.24931 32.5429 0.307009 33.6732C0.364709 34.8036 0.709246 35.9007 1.30816 36.8611C1.90707 37.8214 2.74063 38.6135 3.73031 39.1627C4.71999 39.7119 5.83319 40 6.96502 40H33.0334C34.1653 40.0003 35.2787 39.7124 36.2686 39.1633C37.2585 38.6143 38.0923 37.8222 38.6914 36.8618C39.2906 35.9013 39.6352 34.8041 39.693 33.6736C39.7508 32.5431 39.5198 31.4166 39.0217 30.4L38.01 28.3334H1.99002L0.978356 30.4Z"
        fill="#6933FF"
      />
      <path
        d="M32.2952 16.6666H7.7052L3.62354 25H36.3769L32.2952 16.6666Z"
        fill="#6933FF"
      />
      <path
        d="M25.9885 3.79171C25.4399 2.67127 24.5879 1.72724 23.5295 1.06696C22.471 0.406682 21.2485 0.0566406 20.001 0.0566406C18.7535 0.0566406 17.531 0.406682 16.4725 1.06696C15.414 1.72724 14.5621 2.67127 14.0135 3.79171L9.3335 13.3334H30.6668L25.9885 3.79171Z"
        fill="#6933FF"
      />
    </svg>
  ),

  cursor: (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9685 15.6266L18.6668 13.6333V4.29997C18.6773 3.29691 18.3345 2.32213 17.6986 1.54634C17.0627 0.770553 16.1741 0.243203 15.1885 0.0566395C14.5913 -0.0433841 13.9796 -0.0120637 13.3957 0.14842C12.8119 0.308905 12.2701 0.594697 11.808 0.985902C11.3459 1.37711 10.9746 1.86432 10.7199 2.41364C10.4653 2.96296 10.3334 3.56117 10.3335 4.16664V28.3333C10.3335 28.7753 10.1579 29.1993 9.84533 29.5118C9.53277 29.8244 9.10885 30 8.66682 30C8.22479 30 7.80087 29.8244 7.48831 29.5118C7.17575 29.1993 7.00015 28.7753 7.00015 28.3333V16.1L2.35182 22.1666C0.988473 23.7623 0.274455 25.8119 0.351323 27.9092C0.42819 30.0066 1.29033 31.9984 2.76682 33.49L6.76682 37.5316C8.33639 39.1065 10.4667 39.9942 12.6902 40H25.3335C27.5436 40 29.6632 39.122 31.226 37.5592C32.7888 35.9964 33.6668 33.8768 33.6668 31.6666V23.7983C33.6669 21.8719 32.9995 20.005 31.7783 18.5152C30.5571 17.0253 28.8574 16.0046 26.9685 15.6266Z"
        fill="#6933FF"
      />
    </svg>
  ),

  users: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 21.6667C11.0166 21.6667 9.56659 21.2268 8.33322 20.4027C7.09985 19.5786 6.13856 18.4072 5.5709 17.0368C5.00325 15.6664 4.85472 14.1584 5.14411 12.7035C5.4335 11.2486 6.14781 9.91226 7.1967 8.86337C8.24559 7.81448 9.58197 7.10017 11.0368 6.81078C12.4917 6.52139 13.9997 6.66992 15.3701 7.23757C16.7406 7.80523 17.9119 8.76652 18.736 9.99989C19.5601 11.2333 20 12.6833 20 14.1667C19.9978 16.1551 19.2069 18.0615 17.8009 19.4675C16.3948 20.8736 14.4884 21.6645 12.5 21.6667ZM23.3333 40H1.66667C1.22464 40 0.800716 39.8244 0.488155 39.5119C0.175595 39.1993 0 38.7754 0 38.3333V37.5C0 34.1848 1.31696 31.0054 3.66117 28.6612C6.00537 26.317 9.18479 25 12.5 25C15.8152 25 18.9946 26.317 21.3388 28.6612C23.683 31.0054 25 34.1848 25 37.5V38.3333C25 38.7754 24.8244 39.1993 24.5118 39.5119C24.1993 39.8244 23.7754 40 23.3333 40ZM29.1667 15C27.6833 15 26.2333 14.5601 24.9999 13.736C23.7665 12.9119 22.8052 11.7406 22.2376 10.3701C21.6699 8.99968 21.5214 7.49168 21.8108 6.03683C22.1002 4.58197 22.8145 3.2456 23.8634 2.1967C24.9123 1.14781 26.2486 0.433503 27.7035 0.144114C29.1583 -0.145275 30.6663 0.00324965 32.0368 0.570907C33.4072 1.13856 34.5786 2.09986 35.4027 3.33323C36.2268 4.5666 36.6667 6.01664 36.6667 7.5C36.6645 9.48845 35.8736 11.3948 34.4675 12.8009C33.0615 14.2069 31.1551 14.9978 29.1667 15ZM26.7983 18.3683C25.246 18.5766 23.7535 19.1032 22.4142 19.9151C21.0749 20.727 19.9176 21.8067 19.015 23.0867C22.7498 24.7828 25.6844 27.857 27.205 31.6667H38.3333C38.7754 31.6667 39.1993 31.4911 39.5118 31.1785C39.8244 30.866 40 30.442 40 30V29.9367C39.9983 28.2753 39.6422 26.6335 38.9554 25.1208C38.2687 23.608 37.2672 22.2592 36.0177 21.1643C34.7682 20.0694 33.2995 19.2536 31.7097 18.7715C30.1199 18.2893 28.4455 18.1519 26.7983 18.3683Z"
        fill="#6933FF"
      />
    </svg>
  ),

  chart: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 40C17.25 40 15 37.75 15 35V5C15 2.25 17.25 0 20 0C22.75 0 25 2.25 25 5V35C25 37.75 22.75 40 20 40ZM35 40C32.25 40 30 37.75 30 35V15C30 12.25 32.25 10 35 10C37.75 10 40 12.25 40 15V35C40 37.75 37.75 40 35 40ZM5 40C2.25 40 0 37.75 0 35V25C0 22.25 2.25 20 5 20C7.75 20 10 22.25 10 25V35C10 37.75 7.75 40 5 40Z"
        fill="#A88EFF"
      />
    </svg>
  ),

  copy: (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6668 6.66667C18.6668 7.10869 18.8424 7.53262 19.155 7.84518C19.4675 8.15774 19.8915 8.33333 20.3335 8.33333H26.9435C26.8208 7.25113 26.3459 6.23923 25.5918 5.45333L21.7852 1.52167C20.9524 0.67758 19.8477 0.155624 18.6668 0.0483333V6.66667ZM15.3335 6.66667V0H8.66683C6.4575 0.00264643 4.33943 0.88147 2.7772 2.4437C1.21497 4.00593 0.336143 6.12401 0.333496 8.33333V25C0.336143 27.2093 1.21497 29.3274 2.7772 30.8896C4.33943 32.4519 6.4575 33.3307 8.66683 33.3333H18.6668C20.8762 33.3307 22.9942 32.4519 24.5565 30.8896C26.1187 29.3274 26.9975 27.2093 27.0002 25V11.6667H20.3335C19.0074 11.6667 17.7356 11.1399 16.798 10.2022C15.8603 9.26452 15.3335 7.99275 15.3335 6.66667ZM25.3335 40H10.3335C9.89147 40 9.46755 39.8244 9.15499 39.5118C8.84243 39.1993 8.66683 38.7754 8.66683 38.3333C8.66683 37.8913 8.84243 37.4674 9.15499 37.1548C9.46755 36.8423 9.89147 36.6667 10.3335 36.6667H25.3335C26.6596 36.6667 27.9314 36.1399 28.869 35.2022C29.8067 34.2645 30.3335 32.9927 30.3335 31.6667V13.3333C30.3335 12.8913 30.5091 12.4674 30.8217 12.1548C31.1342 11.8423 31.5581 11.6667 32.0002 11.6667C32.4422 11.6667 32.8661 11.8423 33.1787 12.1548C33.4912 12.4674 33.6668 12.8913 33.6668 13.3333V31.6667C33.6642 33.876 32.7854 35.9941 31.2231 37.5563C29.6609 39.1185 27.5428 39.9974 25.3335 40Z"
        fill="#6933FF"
      />
    </svg>
  ),

  cart: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_26760)">
        <rect width="40" height="40" fill="#160F29" />
        <path
          d="M37.855 6.795C37.3862 6.2324 36.7993 5.77992 36.1359 5.46969C35.4725 5.15947 34.749 4.99911 34.0167 5H7.07L7 4.415C6.85675 3.19903 6.27231 2.07789 5.35748 1.26413C4.44266 0.450372 3.26105 0.000569656 2.03667 0L1.66667 0C1.22464 0 0.800716 0.175595 0.488155 0.488155C0.175595 0.800716 0 1.22464 0 1.66667C0 2.10869 0.175595 2.53262 0.488155 2.84518C0.800716 3.15774 1.22464 3.33333 1.66667 3.33333H2.03667C2.44489 3.33339 2.8389 3.48326 3.14395 3.75453C3.44901 4.02579 3.6439 4.39958 3.69167 4.805L5.985 24.305C6.22309 26.333 7.19746 28.203 8.72318 29.56C10.2489 30.9171 12.2198 31.6667 14.2617 31.6667H31.6667C32.1087 31.6667 32.5326 31.4911 32.8452 31.1785C33.1577 30.866 33.3333 30.442 33.3333 30C33.3333 29.558 33.1577 29.1341 32.8452 28.8215C32.5326 28.5089 32.1087 28.3333 31.6667 28.3333H14.2617C13.2301 28.3304 12.2247 28.0085 11.3832 27.4118C10.5418 26.815 9.90552 25.9726 9.56167 25H29.4283C31.3822 25.0001 33.2739 24.3137 34.773 23.0607C36.2722 21.8077 37.2834 20.0678 37.63 18.145L38.9383 10.8883C39.0689 10.1683 39.0396 9.42844 38.8524 8.72106C38.6651 8.01368 38.3246 7.35613 37.855 6.795Z"
          fill="#A88EFF"
        />
        <path
          d="M11.6668 40C13.5078 40 15.0002 38.5077 15.0002 36.6667C15.0002 34.8258 13.5078 33.3334 11.6668 33.3334C9.82588 33.3334 8.3335 34.8258 8.3335 36.6667C8.3335 38.5077 9.82588 40 11.6668 40Z"
          fill="#A88EFF"
        />
        <path
          d="M28.3333 40C30.1743 40 31.6667 38.5077 31.6667 36.6667C31.6667 34.8258 30.1743 33.3334 28.3333 33.3334C26.4924 33.3334 25 34.8258 25 36.6667C25 38.5077 26.4924 40 28.3333 40Z"
          fill="#A88EFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_26760">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  fingerPrint: (
    <svg
      width="39"
      height="40"
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.95333 37.1418C9.58902 37.1416 9.23479 37.0222 8.94483 36.8016C8.65487 36.581 8.44517 36.2715 8.34781 35.9205C8.25045 35.5694 8.2708 35.1961 8.40574 34.8577C8.54069 34.5193 8.78279 34.2345 9.095 34.0468C15 30.5001 15 22.8834 15 18.3334C15 17.0073 15.5268 15.7356 16.4645 14.7979C17.4021 13.8602 18.6739 13.3334 20 13.3334C21.3261 13.3334 22.5979 13.8602 23.5355 14.7979C24.4732 15.7356 25 17.0073 25 18.3334C25 18.7754 24.8244 19.1994 24.5118 19.5119C24.1993 19.8245 23.7754 20.0001 23.3333 20.0001C22.8913 20.0001 22.4674 19.8245 22.1548 19.5119C21.8423 19.1994 21.6667 18.7754 21.6667 18.3334C21.6667 17.8914 21.4911 17.4675 21.1785 17.1549C20.866 16.8423 20.442 16.6668 20 16.6668C19.558 16.6668 19.1341 16.8423 18.8215 17.1549C18.5089 17.4675 18.3333 17.8914 18.3333 18.3334C18.3333 23.2451 18.3333 32.3901 10.81 36.9051C10.5511 37.0601 10.255 37.1419 9.95333 37.1418ZM18.225 39.5101C22.0283 35.6768 24.25 30.2868 24.8267 23.4751C24.8461 23.2566 24.8222 23.0364 24.7564 22.8271C24.6905 22.6179 24.584 22.4237 24.443 22.2557C24.3019 22.0877 24.1291 21.9492 23.9344 21.8481C23.7397 21.747 23.5269 21.6854 23.3083 21.6668C23.0896 21.6443 22.8686 21.6661 22.6586 21.7309C22.4485 21.7957 22.2535 21.9021 22.0854 22.0438C21.9173 22.1854 21.7794 22.3595 21.68 22.5556C21.5806 22.7517 21.5216 22.9657 21.5067 23.1851C20.9883 29.2801 19.1417 33.8518 15.86 37.1534C15.5484 37.467 15.3741 37.8916 15.3755 38.3337C15.3769 38.7758 15.5539 39.1993 15.8675 39.5109C16.1811 39.8225 16.6057 39.9968 17.0478 39.9954C17.4899 39.994 17.9134 39.817 18.225 39.5034V39.5101ZM26.8917 39.2001C27.9026 37.5203 28.7445 35.7444 29.405 33.8984C29.5431 33.4856 29.5141 33.0351 29.3244 32.6433C29.1346 32.2515 28.7991 31.9495 28.3895 31.8019C27.98 31.6543 27.529 31.6728 27.1329 31.8534C26.7368 32.034 26.4271 32.3624 26.27 32.7684C25.6832 34.4052 24.9362 35.9801 24.04 37.4701C23.9264 37.6573 23.8508 37.8651 23.8175 38.0816C23.7842 38.298 23.7939 38.5189 23.846 38.7317C23.898 38.9444 23.9915 39.1448 24.121 39.3214C24.2506 39.498 24.4136 39.6473 24.6008 39.7609C24.979 39.9903 25.4328 40.0601 25.8624 39.9549C26.0751 39.9029 26.2755 39.8094 26.4521 39.6799C26.6287 39.5504 26.7781 39.3873 26.8917 39.2001ZM30.8333 28.6518C31.4508 25.2482 31.7299 21.7919 31.6667 18.3334C31.6651 15.9722 30.9471 13.6671 29.6076 11.7227C28.2681 9.77824 26.3701 8.286 24.1645 7.44315C21.9589 6.60031 19.5495 6.44655 17.2546 7.00218C14.9597 7.55781 12.8875 8.79669 11.3117 10.5551C11.1582 10.7168 11.0387 10.9076 10.9603 11.1162C10.8819 11.3249 10.8461 11.5472 10.8551 11.7699C10.8642 11.9926 10.9178 12.2113 11.0128 12.4129C11.1078 12.6146 11.2423 12.7951 11.4083 12.9439C11.5743 13.0926 11.7685 13.2066 11.9794 13.2789C12.1902 13.3513 12.4134 13.3806 12.6358 13.3652C12.8582 13.3498 13.0752 13.2899 13.274 13.1891C13.4728 13.0883 13.6494 12.9487 13.7933 12.7784C14.9188 11.5222 16.399 10.6371 18.0382 10.24C19.6774 9.84297 21.3985 9.95265 22.9741 10.5546C24.5496 11.1565 25.9055 12.2224 26.8624 13.6113C27.8193 15.0002 28.3322 16.6468 28.3333 18.3334C28.3948 21.5781 28.1369 24.8209 27.5633 28.0151C27.4792 28.4487 27.5706 28.898 27.8175 29.2642C28.0643 29.6305 28.4465 29.8838 28.88 29.9684C28.9859 29.9896 29.0937 30.0002 29.2017 30.0001C29.5877 29.9991 29.9614 29.8641 30.259 29.6182C30.5566 29.3723 30.7596 29.0307 30.8333 28.6518ZM11.6667 18.3334C11.6662 17.8682 11.7047 17.4038 11.7817 16.9451C11.8314 16.7242 11.8357 16.4956 11.7942 16.273C11.7526 16.0505 11.6662 15.8387 11.5401 15.6507C11.4141 15.4626 11.251 15.3022 11.0609 15.1793C10.8709 15.0563 10.6577 14.9734 10.4345 14.9355C10.2113 14.8977 9.98273 14.9057 9.76272 14.9591C9.54272 15.0124 9.3359 15.1101 9.15488 15.246C8.97386 15.382 8.82243 15.5534 8.70984 15.7498C8.59725 15.9462 8.52585 16.1635 8.5 16.3884C8.38998 17.0309 8.33423 17.6816 8.33333 18.3334C8.33333 26.0751 6.09 30.0001 1.66667 30.0001C1.22464 30.0001 0.800716 30.1757 0.488155 30.4882C0.175595 30.8008 0 31.2247 0 31.6668C0 32.1088 0.175595 32.5327 0.488155 32.8453C0.800716 33.1578 1.22464 33.3334 1.66667 33.3334C8.115 33.3334 11.6667 28.0001 11.6667 18.3334ZM34.5 39.0234C37.2428 32.4803 38.55 25.4249 38.3333 18.3334C38.341 15.565 37.7138 12.8316 36.5 10.3434C36.4042 10.1464 36.2706 9.97024 36.1068 9.8249C35.9429 9.67955 35.7521 9.56791 35.5451 9.49633C35.3381 9.42475 35.119 9.39464 34.9004 9.40773C34.6817 9.42081 34.4678 9.47683 34.2708 9.57259C34.0739 9.66834 33.8977 9.80196 33.7523 9.96581C33.607 10.1297 33.4953 10.3205 33.4237 10.5275C33.3522 10.7345 33.3221 10.9536 33.3351 11.1722C33.3482 11.3909 33.4042 11.6048 33.5 11.8018C34.4917 13.836 35.0048 16.0703 35 18.3334C35.2098 24.948 34.0058 31.5313 31.4683 37.6434C31.378 37.843 31.3279 38.0584 31.3209 38.2774C31.3139 38.4964 31.3501 38.7146 31.4275 38.9195C31.5049 39.1245 31.622 39.3122 31.7719 39.4718C31.9219 39.6315 32.102 39.76 32.3017 39.8501C32.5175 39.9494 32.7524 40.0005 32.99 40.0001C33.3087 39.9987 33.6204 39.906 33.888 39.7329C34.1557 39.5598 34.368 39.3136 34.5 39.0234ZM5 23.3334V18.3334C5.00441 14.3565 6.58618 10.5438 9.39827 7.73169C12.2104 4.9196 16.0231 3.33783 20 3.33342C23.2473 3.3226 26.4087 4.37639 29 6.33342C29.3536 6.59864 29.7981 6.71251 30.2357 6.65C30.6733 6.58749 31.0681 6.35371 31.3333 6.00009C31.5986 5.64646 31.7124 5.20197 31.6499 4.76438C31.5874 4.3268 31.3536 3.93197 31 3.66675C27.8323 1.27579 23.9688 -0.012058 20 8.50908e-05C15.1395 0.00581921 10.4796 1.9392 7.04271 5.37613C3.60578 8.81305 1.6724 13.4729 1.66667 18.3334V23.3334C1.66667 23.7754 1.84226 24.1994 2.15482 24.5119C2.46738 24.8245 2.89131 25.0001 3.33333 25.0001C3.77536 25.0001 4.19928 24.8245 4.51185 24.5119C4.82441 24.1994 5 23.7754 5 23.3334Z"
        fill="#A88EFF"
      />
    </svg>
  ),

  exclamation: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 40C23.9556 40 27.8224 38.827 31.1114 36.6294C34.4004 34.4318 36.9638 31.3082 38.4776 27.6537C39.9913 23.9992 40.3874 19.9778 39.6157 16.0982C38.844 12.2186 36.9392 8.65492 34.1421 5.85787C31.3451 3.06082 27.7814 1.15601 23.9018 0.384303C20.0222 -0.387401 16.0009 0.00866572 12.3463 1.52242C8.69181 3.03617 5.56824 5.59962 3.37061 8.8886C1.17298 12.1776 0 16.0444 0 20C0.00573514 25.3026 2.11471 30.3863 5.8642 34.1358C9.61368 37.8853 14.6974 39.9943 20 40ZM20 8.33334C20.4945 8.33334 20.9778 8.47996 21.3889 8.75467C21.8 9.02937 22.1205 9.41982 22.3097 9.87663C22.4989 10.3334 22.5484 10.8361 22.452 11.3211C22.3555 11.806 22.1174 12.2515 21.7678 12.6011C21.4181 12.9507 20.9727 13.1888 20.4877 13.2853C20.0028 13.3818 19.5001 13.3323 19.0433 13.143C18.5865 12.9538 18.196 12.6334 17.9213 12.2223C17.6466 11.8111 17.5 11.3278 17.5 10.8333C17.5 10.1703 17.7634 9.53442 18.2322 9.06557C18.7011 8.59673 19.337 8.33334 20 8.33334ZM18.3333 16.6667H20C20.8841 16.6667 21.7319 17.0179 22.357 17.643C22.9821 18.2681 23.3333 19.116 23.3333 20V30C23.3333 30.442 23.1577 30.866 22.8452 31.1785C22.5326 31.4911 22.1087 31.6667 21.6667 31.6667C21.2246 31.6667 20.8007 31.4911 20.4882 31.1785C20.1756 30.866 20 30.442 20 30V20H18.3333C17.8913 20 17.4674 19.8244 17.1548 19.5119C16.8423 19.1993 16.6667 18.7754 16.6667 18.3333C16.6667 17.8913 16.8423 17.4674 17.1548 17.1548C17.4674 16.8423 17.8913 16.6667 18.3333 16.6667Z"
        fill="#A88EFF"
      />
    </svg>
  ),

  chevronRight: (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5 5L1 9"
        stroke="#9D93B8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  visa: (
    <svg
      width="100"
      height="60"
      viewBox="0 0 100 60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="60" fill="#142787" />
      <text
        x="20"
        y="40"
        fontSize="30"
        fill="white"
        fontFamily="Arial"
        fontWeight="bold"
      >
        VISA
      </text>
    </svg>
  ),

  mastercard: (
    <svg
      width="100"
      height="60"
      viewBox="0 0 100 60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="60" fill="white" />
      <circle cx="40" cy="30" r="20" fill="#EB001B" />
      <circle cx="60" cy="30" r="20" fill="#F79E1B" />
      <text
        x="15"
        y="50"
        fontSize="12"
        fill="black"
        fontFamily="Arial"
        fontWeight="bold"
      >
        Mastercard
      </text>
    </svg>
  ),

  amex: (
    <svg
      width="100"
      height="60"
      viewBox="0 0 100 60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="60" fill="#0077C8" />
      <text
        x="10"
        y="40"
        fontSize="20"
        fill="white"
        fontFamily="Arial"
        fontWeight="bold"
      >
        AMEX
      </text>
    </svg>
  ),

  diners: (
    <svg
      width="100"
      height="60"
      viewBox="0 0 100 60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="60" fill="white" />
      <circle
        cx="50"
        cy="30"
        r="20"
        stroke="black"
        strokeWidth="3"
        fill="white"
      />
      <text
        x="20"
        y="50"
        fontSize="10"
        fill="black"
        fontFamily="Arial"
        fontWeight="bold"
      >
        Diners
      </text>
    </svg>
  ),

  chartThree: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.6667 30.3067V30C36.664 27.7907 35.7852 25.6726 34.223 24.1104C32.6607 22.5481 30.5427 21.6693 28.3333 21.6667H21.6667V19.85C24.139 19.4321 26.3641 18.1007 27.9011 16.1196C29.438 14.1384 30.1747 11.6522 29.965 9.15361C29.7553 6.65499 28.6146 4.32632 26.769 2.62907C24.9233 0.931826 22.5074 -0.0101318 20 -0.0101318C17.4926 -0.0101318 15.0767 0.931826 13.2311 2.62907C11.3854 4.32632 10.2447 6.65499 10.035 9.15361C9.82535 11.6522 10.562 14.1384 12.0989 16.1196C13.6359 18.1007 15.861 19.4321 18.3333 19.85V21.6667H11.6667C9.45735 21.6693 7.33927 22.5481 5.77704 24.1104C4.21481 25.6726 3.33599 27.7907 3.33334 30V30.3067C2.22132 30.6998 1.28409 31.4735 0.687291 32.4908C0.0904958 33.5082 -0.127435 34.7037 0.0720175 35.8662C0.27147 37.0287 0.875462 38.0833 1.77724 38.8435C2.67902 39.6037 3.82053 40.0207 5.00001 40.0207C6.17949 40.0207 7.321 39.6037 8.22278 38.8435C9.12456 38.0833 9.72855 37.0287 9.928 35.8662C10.1275 34.7037 9.90952 33.5082 9.31273 32.4908C8.71593 31.4735 7.7787 30.6998 6.66668 30.3067V30C6.66668 28.6739 7.19346 27.4021 8.13114 26.4645C9.06882 25.5268 10.3406 25 11.6667 25H18.3333V30.3067C17.2213 30.6998 16.2841 31.4735 15.6873 32.4908C15.0905 33.5082 14.8726 34.7037 15.072 35.8662C15.2715 37.0287 15.8755 38.0833 16.7772 38.8435C17.679 39.6037 18.8205 40.0207 20 40.0207C21.1795 40.0207 22.321 39.6037 23.2228 38.8435C24.1246 38.0833 24.7286 37.0287 24.928 35.8662C25.1275 34.7037 24.9095 33.5082 24.3127 32.4908C23.7159 31.4735 22.7787 30.6998 21.6667 30.3067V25H28.3333C29.6594 25 30.9312 25.5268 31.8689 26.4645C32.8066 27.4021 33.3333 28.6739 33.3333 30V30.3067C32.2213 30.6998 31.2841 31.4735 30.6873 32.4908C30.0905 33.5082 29.8726 34.7037 30.072 35.8662C30.2715 37.0287 30.8755 38.0833 31.7772 38.8435C32.679 39.6037 33.8205 40.0207 35 40.0207C36.1795 40.0207 37.321 39.6037 38.2228 38.8435C39.1246 38.0833 39.7285 37.0287 39.928 35.8662C40.1275 34.7037 39.9095 33.5082 39.3127 32.4908C38.7159 31.4735 37.7787 30.6998 36.6667 30.3067Z"
        fill="#006BFF"
      />
    </svg>
  ),

  checkedAround: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_14083)">
        <rect width="40" height="40" fill="white" />
        <path
          d="M20 0C8.97167 0 0 8.97167 0 20C0 31.0283 8.97167 40 20 40C31.0283 40 40 31.0283 40 20C40 8.97167 31.0283 0 20 0ZM19.8483 25.6983C19.2033 26.3433 18.355 26.665 17.5033 26.665C16.6517 26.665 15.795 26.34 15.1433 25.69L10.5067 21.1967L12.8283 18.8017L17.4833 23.3133L27.165 13.8117L29.505 16.1867L19.8483 25.6983Z"
          fill="#006BFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_14083">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  userPen: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_14085)">
        <rect width="40" height="40" fill="transparent" />
        <path
          d="M15 20C9.485 20 5 15.515 5 10C5 4.485 9.485 0 15 0C20.515 0 25 4.485 25 10C25 15.515 20.515 20 15 20ZM22.1167 32.4667C20.7617 33.8217 20 35.6583 20 37.575V40H22.425C24.3417 40 26.1783 39.2383 27.5333 37.8833L38.8783 26.5383C40.3733 25.0433 40.3733 22.6167 38.8783 21.1217C37.3833 19.6267 34.9567 19.6267 33.4617 21.1217L22.1167 32.4667ZM16.6667 37.575C16.6667 34.755 17.765 32.1033 19.7583 30.11L23.7183 26.15C21.2583 24.3833 18.2533 23.3317 15 23.3317C6.73 23.3333 0 30.0633 0 38.3333C0 39.2533 0.746667 40 1.66667 40H16.6667V37.575Z"
          fill="#006BFF"
        />
      </g>
    </svg>
  ),

  door: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 25C40 26.0283 39.6 26.995 38.87 27.7233L35.4167 31.1783C35.0917 31.5033 34.665 31.6666 34.2383 31.6666C33.8117 31.6666 33.385 31.5033 33.06 31.1783C32.4083 30.5266 32.4083 29.4733 33.06 28.8216L35.2133 26.6666H25C24.0783 26.6666 23.3333 25.9216 23.3333 25C23.3333 24.0783 24.0783 23.3333 25 23.3333H35.2133L33.06 21.1783C32.4083 20.5266 32.4083 19.4733 33.06 18.8216C33.7117 18.17 34.765 18.17 35.4167 18.8216L38.8717 22.2783C39.6 23.005 40 23.9716 40 25ZM23.3333 18.3333V9.99998C23.3333 8.16165 21.8383 6.66665 20 6.66665V36.665H21.6667C22.5867 36.665 23.3333 35.9183 23.3333 34.9983V31.665C23.3333 30.7433 24.0783 29.9983 25 29.9983C25.9217 29.9983 26.6667 30.7433 26.6667 31.665V34.9983C26.6667 37.755 24.4233 39.9983 21.6667 39.9983H5C2.24333 39.9983 0 37.755 0 34.9983V9.36831C0 5.40998 2.81667 1.97331 6.69833 1.19665L12.0267 0.131647C13.995 -0.261687 16.0117 0.241647 17.5617 1.51331C18.1867 2.02498 18.67 2.65498 19.065 3.33331H20C23.6767 3.33331 26.6667 6.32331 26.6667 9.99998V18.3333C26.6667 19.255 25.9217 20 25 20C24.0783 20 23.3333 19.255 23.3333 18.3333ZM15 20.8333C15 19.4533 13.88 18.3333 12.5 18.3333C11.12 18.3333 10 19.4533 10 20.8333C10 22.2133 11.12 23.3333 12.5 23.3333C13.88 23.3333 15 22.2133 15 20.8333Z"
        fill="#6933FF"
      />
    </svg>
  ),

  filter: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_26669)">
        <path
          d="M26.6667 33.3333C26.3133 33.3333 25.96 33.22 25.6667 33L19 28C18.58 27.6867 18.3333 27.1917 18.3333 26.6667V20.69L8.535 10.8933C7.33 9.68667 6.66667 8.085 6.66667 6.38167C6.66667 2.86333 9.53 0 13.0467 0H33.62C37.1367 0 40 2.86167 40 6.38167C40 8.085 39.3367 9.68667 38.1317 10.8933L28.3333 20.6917V31.6683C28.3333 32.3 27.9767 32.8767 27.4117 33.16C27.175 33.2783 26.92 33.3333 26.6667 33.3333ZM17 30.6667C15.7483 29.73 15 28.235 15 26.6667V22.0717L6.17833 13.25C4.59333 11.6633 3.67 9.61833 3.435 7.42167C1.40333 8.49 0 10.5967 0 13.0483C0 14.7517 0.663333 16.3533 1.86833 17.56L11.6667 27.3567V33.3333C11.6667 33.8583 11.9133 34.3517 12.3333 34.6667L19 39.6667C19.2933 39.8867 19.6467 40 20 40C20.2533 40 20.51 39.9417 20.745 39.825C21.31 39.5433 21.6667 38.965 21.6667 38.3333V34.1667L17 30.6667Z"
          fill="#A88EFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_26669">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  robotHand: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_26669)">
        <path
          d="M26.6667 33.3333C26.3133 33.3333 25.96 33.22 25.6667 33L19 28C18.58 27.6867 18.3333 27.1917 18.3333 26.6667V20.69L8.535 10.8933C7.33 9.68667 6.66667 8.085 6.66667 6.38167C6.66667 2.86333 9.53 0 13.0467 0H33.62C37.1367 0 40 2.86167 40 6.38167C40 8.085 39.3367 9.68667 38.1317 10.8933L28.3333 20.6917V31.6683C28.3333 32.3 27.9767 32.8767 27.4117 33.16C27.175 33.2783 26.92 33.3333 26.6667 33.3333ZM17 30.6667C15.7483 29.73 15 28.235 15 26.6667V22.0717L6.17833 13.25C4.59333 11.6633 3.67 9.61833 3.435 7.42167C1.40333 8.49 0 10.5967 0 13.0483C0 14.7517 0.663333 16.3533 1.86833 17.56L11.6667 27.3567V33.3333C11.6667 33.8583 11.9133 34.3517 12.3333 34.6667L19 39.6667C19.2933 39.8867 19.6467 40 20 40C20.2533 40 20.51 39.9417 20.745 39.825C21.31 39.5433 21.6667 38.965 21.6667 38.3333V34.1667L17 30.6667Z"
          fill="#A88EFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_26669">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  padlockChecked: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_26782)">
        <path
          d="M30 20C24.4767 20 20 24.4767 20 30C20 35.5233 24.4767 40 30 40C35.5233 40 40 35.5233 40 30C40 24.4767 35.5233 20 30 20ZM36.1383 29.52L31.6333 33.8767C30.88 34.62 29.88 34.995 28.8783 34.995C27.8767 34.995 26.8733 34.62 26.1067 33.8717L23.85 31.6517C23.1917 31.0067 23.1833 29.9517 23.8267 29.295C24.47 28.6367 25.525 28.6267 26.1833 29.2717L28.44 31.49C28.68 31.7267 29.0733 31.7217 29.31 31.4867L33.8317 27.1133C34.4933 26.4783 35.55 26.4967 36.1883 27.1617C36.825 27.825 36.8033 28.88 36.14 29.5183L36.1383 29.52ZM16.6667 30C15.7467 30 15 29.255 15 28.3333V25C15 24.0783 15.7467 23.3333 16.6667 23.3333C17.2583 23.3333 17.7533 23.66 18.05 24.1233C20.2267 19.7133 24.7583 16.6667 30 16.6667C30.5867 16.6667 31.16 16.7183 31.7283 16.7917C30.86 15.6017 29.6983 14.6383 28.3333 14.04V11.6667C28.3333 5.23333 23.1 0 16.6667 0C10.2333 0 5 5.23333 5 11.6667V14.04C2.06167 15.33 0 18.2583 0 21.6667V31.6667C0 36.2617 3.73833 40 8.33333 40H21.21C18.4317 37.555 16.6667 33.9833 16.6667 30ZM8.33333 11.6667C8.33333 7.07167 12.0717 3.33333 16.6667 3.33333C21.2617 3.33333 25 7.07167 25 11.6667V13.3333H8.33333V11.6667Z"
          fill="#A88EFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_26782">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  walletUser: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_14236)">
        <path
          d="M31.6667 30C29.3683 30 27.5 28.1317 27.5 25.8333C27.5 23.535 29.3683 21.6667 31.6667 21.6667C33.965 21.6667 35.8333 23.535 35.8333 25.8333C35.8333 28.1317 33.965 30 31.6667 30ZM38.3333 40H25C24.4817 40 23.9933 39.7583 23.6783 39.3467C23.3633 38.935 23.2567 38.4017 23.3917 37.9C24.3767 34.2283 27.78 31.665 31.6683 31.665C35.5567 31.665 38.96 34.2283 39.945 37.9C40.08 38.4 39.9733 38.935 39.6583 39.3467C39.3433 39.7583 38.855 40 38.3367 40H38.3333ZM40 25.8333V11.6667C40 8.91 37.7567 6.66667 35 6.66667H8.33333C6.90167 6.66667 5.54833 6.04667 4.60833 5.00167C5.525 3.97833 6.855 3.33333 8.33333 3.33333H38.3333C39.2533 3.33333 40 2.58667 40 1.66667C40 0.746667 39.2533 0 38.3333 0H8.33333C5.29667 0 2.63333 1.63333 1.17667 4.06667C1.135 4.12833 1.09833 4.19333 1.065 4.26C0.386667 5.465 0 6.855 0 8.33333V25C0 29.595 3.73833 33.3333 8.33333 33.3333H21.9367C22.8817 32.0083 24.0983 30.9117 25.4917 30.075C24.66 28.8667 24.1667 27.4083 24.1667 25.8333C24.1667 21.6983 27.5317 18.3333 31.6667 18.3333C35.8017 18.3333 39.1667 21.6983 39.1667 25.8333H40Z"
          fill="#6933FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_14236">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  callCenter: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.9995 35.8332V39.9999H4.99945V35.8332C4.99945 31.6982 8.36445 28.3332 12.4995 28.3332H27.4995C31.6345 28.3332 34.9995 31.6982 34.9995 35.8332ZM11.4528 6.71152C14.0011 4.32318 17.3378 3.14318 20.8361 3.35985C27.3761 3.78318 32.5011 9.47485 32.5011 16.3165C32.5011 19.2665 30.1028 21.6649 27.1528 21.6649H23.1428C22.7361 20.2832 21.4728 19.2665 19.9595 19.2665C18.1178 19.2665 16.6261 20.7582 16.6261 22.5999C16.6261 24.4415 18.1178 25.9332 19.9595 25.9332C20.8561 25.9332 21.6678 25.5749 22.2661 24.9982H27.1528C31.9395 24.9982 35.8345 21.1032 35.8345 16.3165C35.8328 7.72318 29.3395 0.569849 21.0495 0.0348495C16.6095 -0.253484 12.3978 1.25485 9.17279 4.28152C6.19445 7.07318 4.40445 10.9415 4.18945 15.0015H7.52779C7.73279 11.8299 9.10779 8.90985 11.4528 6.71152ZM25.1661 18.3332H27.4461C28.2811 18.3332 29.0111 17.7198 29.1078 16.8898C29.2211 15.9115 29.1795 14.8865 28.9561 13.8382C28.2161 10.3732 25.4045 7.57818 21.9345 6.86485C16.0395 5.65318 10.8361 10.1482 10.8361 15.8332C10.8361 18.2815 11.8011 20.5082 13.3695 22.1532C13.5528 18.6348 16.4378 15.8315 20.0011 15.8315C22.0978 15.8315 23.9445 16.8182 25.1661 18.3315V18.3332Z"
        fill="#6933FF"
      />
    </svg>
  ),

  speedometer: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_26675)">
        <path
          d="M39.8335 19.0616C39.1786 14.0207 36.6288 9.4182 32.7024 6.18971C28.7759 2.96122 23.7674 1.349 18.6949 1.68072C13.6224 2.01245 8.8666 4.26324 5.39406 7.97561C1.92151 11.688 -0.00713373 16.5833 0.000123423 21.6666C-0.00948391 24.3875 0.541887 27.0811 1.61981 29.5794C2.69774 32.0776 4.27909 34.3269 6.26512 36.1866C7.78402 37.5929 9.78538 38.3615 11.8551 38.3333H28.1335C30.3201 38.3384 32.4209 37.4829 33.9818 35.9516C36.2063 33.7874 37.894 31.133 38.91 28.2004C39.926 25.2678 40.2422 22.1382 39.8335 19.0616ZM12.4535 32.7683C12.3088 32.9328 12.1332 33.0671 11.9367 33.1637C11.7401 33.2602 11.5264 33.3171 11.3079 33.331C11.0893 33.3449 10.8702 33.3157 10.6629 33.2449C10.4557 33.174 10.2644 33.0631 10.1001 32.9183C7.80944 30.9072 6.1864 28.2454 5.44752 25.2881C4.70864 22.3307 4.88904 19.2184 5.96465 16.3662C7.04027 13.514 8.95996 11.0576 11.4677 9.32456C13.9754 7.59155 16.9519 6.66436 20.0001 6.66664C21.2643 6.66703 22.5236 6.82548 23.7485 7.13831C23.9605 7.19303 24.1598 7.28898 24.3348 7.4207C24.5098 7.55241 24.6571 7.7173 24.7684 7.90596C24.8797 8.09462 24.9527 8.30335 24.9833 8.52023C25.0139 8.73711 25.0015 8.95789 24.9468 9.16998C24.8921 9.38206 24.7961 9.58129 24.6644 9.7563C24.5327 9.9313 24.3678 10.0786 24.1791 10.1899C23.9905 10.3012 23.7818 10.3742 23.5649 10.4048C23.348 10.4354 23.1272 10.423 22.9151 10.3683C20.376 9.71019 17.689 9.92771 15.2888 10.9857C12.8886 12.0437 10.9154 13.8803 9.68818 16.1986C8.46099 18.5169 8.05159 21.1813 8.52618 23.7611C9.00076 26.3409 10.3316 28.6852 12.3035 30.415C12.4679 30.5596 12.6023 30.7352 12.6988 30.9318C12.7954 31.1283 12.8522 31.342 12.8662 31.5606C12.8801 31.7791 12.8508 31.9983 12.78 32.2055C12.7092 32.4127 12.5982 32.604 12.4535 32.7683ZM20.0001 25C19.5223 25.0063 19.0487 24.9098 18.6115 24.717C18.1743 24.5243 17.7836 24.2397 17.4659 23.8828C17.1483 23.5258 16.9111 23.1047 16.7705 22.648C16.6298 22.1913 16.589 21.7097 16.6508 21.2359C16.7126 20.762 16.8756 20.307 17.1286 19.9017C17.3817 19.4963 17.7189 19.1502 18.1175 18.8866C18.5161 18.623 18.9667 18.4482 19.4387 18.374C19.9108 18.2998 20.3932 18.328 20.8535 18.4566L27.1551 12.155C27.3089 11.9958 27.4928 11.8688 27.6961 11.7815C27.8995 11.6941 28.1182 11.6482 28.3395 11.6462C28.5608 11.6443 28.7802 11.6865 28.985 11.7703C29.1899 11.8541 29.376 11.9778 29.5324 12.1343C29.6889 12.2908 29.8127 12.4769 29.8965 12.6817C29.9803 12.8865 30.0225 13.106 30.0205 13.3273C30.0186 13.5486 29.9726 13.7673 29.8853 13.9707C29.7979 14.174 29.671 14.3579 29.5118 14.5116L23.2101 20.8133C23.3491 21.3063 23.3712 21.8248 23.2746 22.3278C23.178 22.8308 22.9655 23.3043 22.6539 23.7107C22.3422 24.1172 21.9401 24.4454 21.4794 24.6692C21.0188 24.893 20.5122 25.0062 20.0001 25ZM29.9001 32.9183C29.5669 33.198 29.1375 33.3364 28.7036 33.3038C28.2698 33.2712 27.8659 33.0702 27.5782 32.7438C27.2905 32.4174 27.1419 31.9914 27.164 31.5569C27.1862 31.1224 27.3774 30.7138 27.6968 30.4183C29.3174 28.997 30.5121 27.1541 31.1479 25.0944C31.7838 23.0348 31.8359 20.8391 31.2985 18.7516C31.1879 18.3233 31.2521 17.8686 31.4769 17.4876C31.7016 17.1066 32.0685 16.8305 32.4968 16.72C32.9251 16.6095 33.3798 16.6736 33.7608 16.8984C34.1418 17.1231 34.4179 17.49 34.5285 17.9183C34.8414 19.1432 34.9998 20.4024 35.0001 21.6666C34.9977 23.7967 34.5416 25.9018 33.6622 27.8419C32.7828 29.7819 31.5004 31.5125 29.9001 32.9183Z"
          fill="#A88EFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_26675">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  "brasil-flag": (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_26675)">
        <path
          d="M39.8335 19.0616C39.1786 14.0207 36.6288 9.4182 32.7024 6.18971C28.7759 2.96122 23.7674 1.349 18.6949 1.68072C13.6224 2.01245 8.8666 4.26324 5.39406 7.97561C1.92151 11.688 -0.00713373 16.5833 0.000123423 21.6666C-0.00948391 24.3875 0.541887 27.0811 1.61981 29.5794C2.69774 32.0776 4.27909 34.3269 6.26512 36.1866C7.78402 37.5929 9.78538 38.3615 11.8551 38.3333H28.1335C30.3201 38.3384 32.4209 37.4829 33.9818 35.9516C36.2063 33.7874 37.894 31.133 38.91 28.2004C39.926 25.2678 40.2422 22.1382 39.8335 19.0616ZM12.4535 32.7683C12.3088 32.9328 12.1332 33.0671 11.9367 33.1637C11.7401 33.2602 11.5264 33.3171 11.3079 33.331C11.0893 33.3449 10.8702 33.3157 10.6629 33.2449C10.4557 33.174 10.2644 33.0631 10.1001 32.9183C7.80944 30.9072 6.1864 28.2454 5.44752 25.2881C4.70864 22.3307 4.88904 19.2184 5.96465 16.3662C7.04027 13.514 8.95996 11.0576 11.4677 9.32456C13.9754 7.59155 16.9519 6.66436 20.0001 6.66664C21.2643 6.66703 22.5236 6.82548 23.7485 7.13831C23.9605 7.19303 24.1598 7.28898 24.3348 7.4207C24.5098 7.55241 24.6571 7.7173 24.7684 7.90596C24.8797 8.09462 24.9527 8.30335 24.9833 8.52023C25.0139 8.73711 25.0015 8.95789 24.9468 9.16998C24.8921 9.38206 24.7961 9.58129 24.6644 9.7563C24.5327 9.9313 24.3678 10.0786 24.1791 10.1899C23.9905 10.3012 23.7818 10.3742 23.5649 10.4048C23.348 10.4354 23.1272 10.423 22.9151 10.3683C20.376 9.71019 17.689 9.92771 15.2888 10.9857C12.8886 12.0437 10.9154 13.8803 9.68818 16.1986C8.46099 18.5169 8.05159 21.1813 8.52618 23.7611C9.00076 26.3409 10.3316 28.6852 12.3035 30.415C12.4679 30.5596 12.6023 30.7352 12.6988 30.9318C12.7954 31.1283 12.8522 31.342 12.8662 31.5606C12.8801 31.7791 12.8508 31.9983 12.78 32.2055C12.7092 32.4127 12.5982 32.604 12.4535 32.7683ZM20.0001 25C19.5223 25.0063 19.0487 24.9098 18.6115 24.717C18.1743 24.5243 17.7836 24.2397 17.4659 23.8828C17.1483 23.5258 16.9111 23.1047 16.7705 22.648C16.6298 22.1913 16.589 21.7097 16.6508 21.2359C16.7126 20.762 16.8756 20.307 17.1286 19.9017C17.3817 19.4963 17.7189 19.1502 18.1175 18.8866C18.5161 18.623 18.9667 18.4482 19.4387 18.374C19.9108 18.2998 20.3932 18.328 20.8535 18.4566L27.1551 12.155C27.3089 11.9958 27.4928 11.8688 27.6961 11.7815C27.8995 11.6941 28.1182 11.6482 28.3395 11.6462C28.5608 11.6443 28.7802 11.6865 28.985 11.7703C29.1899 11.8541 29.376 11.9778 29.5324 12.1343C29.6889 12.2908 29.8127 12.4769 29.8965 12.6817C29.9803 12.8865 30.0225 13.106 30.0205 13.3273C30.0186 13.5486 29.9726 13.7673 29.8853 13.9707C29.7979 14.174 29.671 14.3579 29.5118 14.5116L23.2101 20.8133C23.3491 21.3063 23.3712 21.8248 23.2746 22.3278C23.178 22.8308 22.9655 23.3043 22.6539 23.7107C22.3422 24.1172 21.9401 24.4454 21.4794 24.6692C21.0188 24.893 20.5122 25.0062 20.0001 25ZM29.9001 32.9183C29.5669 33.198 29.1375 33.3364 28.7036 33.3038C28.2698 33.2712 27.8659 33.0702 27.5782 32.7438C27.2905 32.4174 27.1419 31.9914 27.164 31.5569C27.1862 31.1224 27.3774 30.7138 27.6968 30.4183C29.3174 28.997 30.5121 27.1541 31.1479 25.0944C31.7838 23.0348 31.8359 20.8391 31.2985 18.7516C31.1879 18.3233 31.2521 17.8686 31.4769 17.4876C31.7016 17.1066 32.0685 16.8305 32.4968 16.72C32.9251 16.6095 33.3798 16.6736 33.7608 16.8984C34.1418 17.1231 34.4179 17.49 34.5285 17.9183C34.8414 19.1432 34.9998 20.4024 35.0001 21.6666C34.9977 23.7967 34.5416 25.9018 33.6622 27.8419C32.7828 29.7819 31.5004 31.5125 29.9001 32.9183Z"
          fill="#A88EFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_26675">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  "portugal-flag": (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_26669)">
        <path
          d="M26.6667 33.3333C26.3133 33.3333 25.96 33.22 25.6667 33L19 28C18.58 27.6867 18.3333 27.1917 18.3333 26.6667V20.69L8.535 10.8933C7.33 9.68667 6.66667 8.085 6.66667 6.38167C6.66667 2.86333 9.53 0 13.0467 0H33.62C37.1367 0 40 2.86167 40 6.38167C40 8.085 39.3367 9.68667 38.1317 10.8933L28.3333 20.6917V31.6683C28.3333 32.3 27.9767 32.8767 27.4117 33.16C27.175 33.2783 26.92 33.3333 26.6667 33.3333ZM17 30.6667C15.7483 29.73 15 28.235 15 26.6667V22.0717L6.17833 13.25C4.59333 11.6633 3.67 9.61833 3.435 7.42167C1.40333 8.49 0 10.5967 0 13.0483C0 14.7517 0.663333 16.3533 1.86833 17.56L11.6667 27.3567V33.3333C11.6667 33.8583 11.9133 34.3517 12.3333 34.6667L19 39.6667C19.2933 39.8867 19.6467 40 20 40C20.2533 40 20.51 39.9417 20.745 39.825C21.31 39.5433 21.6667 38.965 21.6667 38.3333V34.1667L17 30.6667Z"
          fill="#A88EFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_26669">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  "usa-flag": (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3648_14236)">
        <path
          d="M31.6667 30C29.3683 30 27.5 28.1317 27.5 25.8333C27.5 23.535 29.3683 21.6667 31.6667 21.6667C33.965 21.6667 35.8333 23.535 35.8333 25.8333C35.8333 28.1317 33.965 30 31.6667 30ZM38.3333 40H25C24.4817 40 23.9933 39.7583 23.6783 39.3467C23.3633 38.935 23.2567 38.4017 23.3917 37.9C24.3767 34.2283 27.78 31.665 31.6683 31.665C35.5567 31.665 38.96 34.2283 39.945 37.9C40.08 38.4 39.9733 38.935 39.6583 39.3467C39.3433 39.7583 38.855 40 38.3367 40H38.3333ZM40 25.8333V11.6667C40 8.91 37.7567 6.66667 35 6.66667H8.33333C6.90167 6.66667 5.54833 6.04667 4.60833 5.00167C5.525 3.97833 6.855 3.33333 8.33333 3.33333H38.3333C39.2533 3.33333 40 2.58667 40 1.66667C40 0.746667 39.2533 0 38.3333 0H8.33333C5.29667 0 2.63333 1.63333 1.17667 4.06667C1.135 4.12833 1.09833 4.19333 1.065 4.26C0.386667 5.465 0 6.855 0 8.33333V25C0 29.595 3.73833 33.3333 8.33333 33.3333H21.9367C22.8817 32.0083 24.0983 30.9117 25.4917 30.075C24.66 28.8667 24.1667 27.4083 24.1667 25.8333C24.1667 21.6983 27.5317 18.3333 31.6667 18.3333C35.8017 18.3333 39.1667 21.6983 39.1667 25.8333H40Z"
          fill="#6933FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3648_14236">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};

export default icons;
